/* MailBakes native personalisation flow - replaces Globo Product Options.
   Writes the same visible line-item property names the bakery already reads.

   Photo cards: products tagged custom-image get an upload inside the message
   step. When a file is present the add has to go as FormData, and
   /cart/add.js only takes one item that way, so the card goes first and the
   slice upgrade and extras follow in a second request. Both carry the same
   group id, so the order they land in does not matter.

   Aug 2026, Revisions 6.84:
     - design gallery alternating the closed card and the open Cake Card
     - quantity options show the price per slice; a bundle keeps its saving
     - descriptions under each quantity option removed
     - letterbox promise limited to the sizes that actually post
     - parcel disclosure on the cake option, delivery step and extras
     - flavour detail view: no Choose button, ingredients folded, allergen out
     - Font and Colour split into two separate folds
     - estimated-date note only while Choose a date is selected
     - quantity steppers on every extra, capped
     - the chosen postage counts towards the running total
     - a step change lands on the new step's heading, clear of the chrome

   Markup strings use template literals with single-quoted HTML attributes. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mb-flow]');
  if (!root) return;

  var D = JSON.parse(document.querySelector('[data-mb-flow-json]').textContent);
  [
    {id:'classic-bold',name:'Classic Bold',stack:'Georgia,"Times New Roman",serif'},
    {id:'modern-bold',name:'Modern Bold',stack:'Inter,Helvetica,Arial,sans-serif'},
    {id:'typewriter-bold',name:'Typewriter Bold',stack:'"Courier New",Courier,monospace'}
  ].forEach(function(f){ if(!D.fonts.some(function(x){return x.id===f.id;})) D.fonts.push(f); });
  [
    {id:'purple',name:'Purple',hex:'#703C8F'}, {id:'teal',name:'Teal',hex:'#087F8C'},
    {id:'orange',name:'Orange',hex:'#B84C12'}, {id:'brown',name:'Brown',hex:'#795548'},
    {id:'berry',name:'Berry',hex:'#8E245D'}
  ].forEach(function(c){ if(!D.colours.some(function(x){return x.id===c.id;})) D.colours.push(c); });
  var FIRST = 2, LAST = 6;
  var cur = FIRST;

  /* The standard postage rate, in pence, as reported by mb-delivery.js. Used
     only to print "plus £4.00 postage" under the running total on the screens
     before the delivery step - it is never added to total() here, because
     postage() already does that from the delivery step onwards. 0 until the
     Delivery product has loaded, and the note is simply not printed until it
     has. */
  var BASE_POSTAGE = 0;

  /* The card preview IS the input - the message is typed straight onto it.
     The prompt sits in the middle of the card as a pseudo-element, so it
     never has to be deleted before the customer can start writing. */
  var SAMPLE = D.preview_sample ||
    'Your message will be printed here, just like this';
  var MAXQ = Math.max(1, parseInt(D.extras_max, 10) || 10);
  // Messages are limited by printable space, not an arbitrary character count.
  var BLANK_PH = D.blank_preview ||
    'No message - the inside will be left blank';

  /* Which rail node is lit for each screen. Choosing the cake spans two. */
  var RAIL = { 2: 0, 3: 0, 4: 1, 5: 2, 6: 3 };

  var S = {
    size: D.sizes.length > 1 ? D.sizes[1].id : D.sizes[0].id,
    flav: [], msg: '', blank: false, font: D.fonts[0].id, colour: D.colours[0].id,
    align: 'center', textSize: 0, video: null, audio: null,
    when: 'asap', date: null, extras: [], qty: {},
    /* AI cards already showed the customer their design on the page before,
       so step 4 opens on the words rather than the front (item 3). */
    face: (D.needs_image && !D.is_ai) ? 'card' : 'msg',
    photo: null, photoUrl: null, gal: 0,
    isEdit: false, editKey: null, editGroup: null
  };

  var $ = function (s) {
    return root.querySelector(s) || document.querySelector(s);
  };
  var $$ = function (s) {
    return Array.prototype.slice.call(root.querySelectorAll(s));
  };
  var money = function (p) { return D.currency + (p / 100).toFixed(2); };

  var AMP = String.fromCharCode(38);
  var LT = String.fromCharCode(60);
  var GT = String.fromCharCode(62);
  var DQ = String.fromCharCode(34);
  var SQ = String.fromCharCode(39);
  var ENT = {};
  ENT[AMP] = AMP + 'amp;';
  ENT[LT] = AMP + 'lt;';
  ENT[GT] = AMP + 'gt;';
  ENT[DQ] = AMP + 'quot;';
  ENT[SQ] = AMP + '#39;';
  var ESC_RE = new RegExp('[' + AMP + LT + GT + DQ + SQ + ']', 'g');
  var esc = function (s) {
    return String(s == null ? '' : s).replace(ESC_RE, function (c) {
      return ENT[c];
    });
  };

  var logoSrc = null;
  function shopLogo() {
    if (logoSrc !== null) return logoSrc;
    var el = document.querySelector('.mbh__logo img, .mb-logo img');
    logoSrc = el ? (el.getAttribute('src') || '') : '';
    return logoSrc;
  }

  var sizeOf = function (id) {
    for (var i = 0; i < D.sizes.length; i++) {
      if (String(D.sizes[i].id) === String(id)) return D.sizes[i];
    }
    return D.sizes[0];
  };
  var extraOf = function (id) {
    for (var i = 0; i < D.extras.length; i++) {
      if (D.extras[i].id === id) return D.extras[i];
    }
    return null;
  };
  var maxFlav = function () { return sizeOf(S.size).slices; };
  var qtyOf = function (id) { return S.qty[id] || 1; };

  /* ---- preview styling ------------------------------------------------ */
  (function injectPreviewCss() {
    if (document.getElementById('mb-pv-css')) return;
    var css = document.createElement('style');
    css.id = 'mb-pv-css';
    css.textContent = [
      '.mb-pv{background:#fff;border:1px solid var(--mb-line,#EDE6E9);',
      'border-radius:6px;width:100%;max-width:390px;margin:0 auto;',
      'aspect-ratio:1/1.414;padding:38px 30px 22px;display:flex;',
      'flex-direction:column;box-shadow:0 6px 22px rgba(30,26,28,.09)}',
      '.mb-pv__m{flex:1;display:flex;align-items:center;',
      'justify-content:center;text-align:center;white-space:pre-line;',
      'overflow-wrap:anywhere;font-size:17px;line-height:1.95;',
      'color:var(--mb-ink,#1E1A1C)}',
      '.mb-pv__m.is-empty{color:var(--mb-ink-30,#A79FA3)}',
      /* The message is typed on the card itself. The caret lives on an inner
         span so the flex centring above is left alone, and the prompt is a
         pseudo-element rather than real text - real text would have to be
         deleted before the customer could start. */
      '.mb-pv__t{display:block;width:100%;outline:none;cursor:text;',
      'border-radius:4px}',
      '.mb-pv__t:empty::before{content:attr(data-ph);',
      'color:var(--mb-ink-30,#A79FA3)}',
      '.mb-pv__t:focus{box-shadow:0 0 0 2px var(--mb-pink-pale,#F8C6DC)}',
      '.mb-pv__m.is-locked .mb-pv__t{cursor:default}',
      /* the old message box stays in the DOM as the value the helper writes
         into and the basket edit restores into - it is just never seen */
      '.mb-msg--off{position:absolute!important;left:-9999px;top:auto;',
      'width:1px;height:1px;opacity:0;pointer-events:none}',
      '.mb-blank{display:flex;align-items:center;gap:9px;margin:14px 0 0;',
      'font-size:14.5px;color:var(--mb-ink,#1E1A1C);cursor:pointer}',
      '.mb-blank input{width:18px;height:18px;accent-color:var(--mb-pink,#ED217A);',
      'cursor:pointer;flex:none}',
      '.mb-pv__logo{flex:none;display:block;height:20px;width:auto;',
      'margin:0 auto;object-fit:contain}',
      '.mb-pv__brand{flex:none;text-align:center;font-size:15px;',
      'font-weight:800;font-style:italic;letter-spacing:-.03em;',
      'color:var(--mb-pink,#ED217A)}',
      '@media(max-width:1100px){',
      '.mb-pv{padding:30px 22px 18px;max-width:320px}',
      '.mb-pv__m{font-size:15.5px;line-height:1.85}',
      '.mb-pv__logo{height:17px}}'
    ].join('');
    document.head.appendChild(css);
  })();

  /* What a size costs on its own. A bundle carries its own price - it is
     not the card plus an upgrade - so the override wins where it is set.
     One helper, used by the option row and the running total, so the two
     can never disagree. */
  function sizePrice(s) {
    return (s && s.price_override != null) ? s.price_override : D.base + s.add;
  }

  function cardQuantity() {
    return Math.max(1, Math.min(10, parseInt(root.getAttribute('data-mb-card-quantity'), 10) || 1));
  }

  function itemTotal() {
    var n = cardQuantity();
    var pct = parseInt(root.getAttribute('data-mb-card-discount-pct'), 10) || 0;
    // Match the native product discount: base card only, rounded per card.
    var t = sizePrice(sizeOf(S.size)) * n - Math.floor(D.base * pct / 100) * n;
    S.extras.forEach(function (id) {
      var e = extraOf(id);
      if (e) t += e.price * qtyOf(id);
    });
    return t;
  }

  /* ---- postage --------------------------------------------------------
     Postage is picked in mb-delivery.js and charged as its own basket line,
     so the running total has to carry it. Read off the selected option
     rather than mirrored in state here: one source of truth, so changing
     the service or stepping back and forward cannot leave the two apart. */

  function postage() {
    var el = document.querySelector('[data-ship].is-on');
    var p = el ? parseInt(el.getAttribute('data-ship-price'), 10) : 0;
    return p > 0 ? p : 0;
  }

  function total() { return itemTotal() + postage(); }

  /* ---- delivery format ------------------------------------------------
     Only the sizes that genuinely post through a letterbox may carry the
     letterbox promise. Anything above the threshold, or any extra ops has
     flagged, turns the order into a parcel and has to say so. */

  function matches(list, title) {
    var t = String(title || '').toLowerCase();
    return String(list || '').split(',').map(function (s) {
      return s.trim().toLowerCase();
    }).filter(Boolean).some(function (s) { return t.indexOf(s) > -1; });
  }

  function isParcel() {
    if (sizeOf(S.size).slices >= (D.parcel_min_slices || 4)) return true;
    var units = S.extras.reduce(function (t, id) { return t + qtyOf(id); }, 0);
    return units > D.parcel_max_extras;
  }

  function renderParcel() {
    var on = isParcel();
    $$('[data-mb-parcel]').forEach(function (el) {
      el.hidden = !on;
      el.textContent = on ? (D.parcel_note || '') : '';
    });
  }

  /* ---- design gallery -------------------------------------------------
     Alternates the closed design and the open Cake Card. Dots and arrows
     are there so it reads as a gallery rather than a single photo. */

  var galTimer = null;

  function renderGallery() {
    var el = document.getElementById('mb-gal');
    if (!el) return;
    var imgs = (D.images && D.images.length)
      ? D.images
      : (D.image ? [{ src: D.image, alt: '' }] : []);
    if (!imgs.length) { el.innerHTML = ''; return; }
    if (S.gal >= imgs.length) S.gal = 0;

    var slides = imgs.map(function (im, i) {
      return `<img src='` + esc(im.src) + `' alt='` + esc(im.alt) + `'` +
        (i === S.gal ? ` class='is-on'` : '') +
        (i === 0 ? '' : ` loading='lazy'`) + '>';
    }).join('');

    var arrows = '';
    var dots = '';
    if (imgs.length > 1) {
      arrows =
        `<button type='button' class='mb-gal__a mb-gal__a--p'` +
        ` data-gal='-1' aria-label='Previous image'>` +
        AMP + 'lsaquo;</button>' +
        `<button type='button' class='mb-gal__a mb-gal__a--n'` +
        ` data-gal='1' aria-label='Next image'>` +
        AMP + 'rsaquo;</button>';
      dots = `<div class='mb-gal__dots'>` + imgs.map(function (im, i) {
        return `<button type='button' data-galgo='` + i + `'` +
          (i === S.gal ? ` class='is-on'` : '') +
          ` aria-label='Image ` + (i + 1) + `'></button>`;
      }).join('') + '</div>';
    }

    el.innerHTML = `<div class='mb-gal__vp' id='mb-gal-vp'>` +
      slides + arrows + '</div>' + dots;
    startGallery();
  }

  function galTo(i, manual) {
    var n = (D.images && D.images.length) || 1;
    S.gal = ((i % n) + n) % n;
    var vp = document.getElementById('mb-gal-vp');
    if (vp) {
      Array.prototype.slice.call(vp.querySelectorAll('img'))
        .forEach(function (im, k) { im.classList.toggle('is-on', k === S.gal); });
    }
    var dots = document.querySelectorAll('[data-galgo]');
    for (var k = 0; k < dots.length; k++) {
      dots[k].classList.toggle('is-on', k === S.gal);
    }
    if (manual) startGallery();
  }

  function startGallery() {
    if (galTimer) clearInterval(galTimer);
    var secs = parseInt(D.gallery_seconds, 10);
    var n = (D.images && D.images.length) || 1;
    if (!secs || n < 2) return;
    galTimer = setInterval(function () {
      if (cur !== FIRST) return;
      galTo(S.gal + 1);
    }, secs * 1000);
  }

  /* ---- sizes ----------------------------------------------------------
     A quantity option now carries what one slice works out at rather than
     what the order saves. Worked out from the option's own price and its
     own slice count, so a price change carries straight through.

     A bundle is the exception and keeps its saving. Its price covers items
     that are not cake, so dividing it by the slice count would quote a
     per-slice rate that is not the price of a slice. Any size that supplies
     its own "save" is treated as a bundle and shows the saving instead. */

  function renderSizes() {
  $('#mb-sizes').innerHTML = D.sizes.map(function (s) {
    /* Anything the size supplies for itself wins. A bundle's saving is
       measured against its own parts, not against single slices. */
    var price = sizePrice(s);
    var extra = '';

    if (s.save != null && s.save > 0) {
      extra = `<span class='mb-opt__save'>` +
        esc(D.save_word || 'Save') + ' ' + money(s.save) + '</span>';
    } else if (s.slices > 0) {
      /* Half a penny rounds up, so 1658 over four reads as 4.15 rather
         than 4.14. money() only ever sees a whole number of pence. */
      extra = `<span class='mb-opt__each'>` +
        money(Math.round(price / s.slices)) +
        ' ' + esc(D.each_word || 'per slice') + '</span>';
    }

    /* a was-price that is not above the price is not a saving */
    var was = (s.was != null && s.was > price)
      ? `<span class='mb-opt__was'>` + money(s.was) + '</span>'
      : '';

    /* what is in it - its own class, because step 1 hides .mb-opt__d */
    var note = s.note
      ? '<span class="mb-opt__note">' + esc(s.note) + '</span>'
      : (s.blurb
          ? '<span class="mb-opt__note">' + esc(s.blurb) + '</span>'
          : '');

    var on = String(S.size) === String(s.id) ? ' is-on' : '';

    var pop = s.popular
  ? '<span class="mb-opt__pop">Most popular</span>'
  : '';

var parcel = (
  on &&
  String(s.title).toLowerCase().indexOf('four') !== -1 &&
  D.parcel_note
)
  ? '<span class="mb-parcel">' + esc(D.parcel_note) + '</span>'
  : '';

    return `<button type='button' class='mb-opt` + on + `'` +
      ` data-size='` + esc(s.id) + `'>` + pop +
      `<span class='mb-opt__rd'></span><span>` +
      `<span class='mb-opt__t'>` + esc(s.title) + `</span>` +
      note + parcel + `</span>` +
      `<span class='mb-opt__p'>` + was +
      `<span class='mb-opt__full'>` + money(price) + `</span>` +
      extra + `</span></button>`;
  }).join('');
}

  /* ---- bundles -------------------------------------------------------- */

  function bundleIds(b) {
    return String(b.ids || '').split(',').map(function (x) {
      return parseInt(x, 10);
    }).filter(function (n) { return !isNaN(n) && !!extraOf(n); });
  }
  function bundlePrice(b) {
    return bundleIds(b).reduce(function (t, id) {
      var e = extraOf(id);
      return t + (e ? e.price : 0);
    }, 0);
  }
  function bundleOn(b) {
    var ids = bundleIds(b);
    return ids.length > 0 && ids.every(function (id) {
      return S.extras.indexOf(id) > -1;
    });
  }
  function renderBundles() {
    var el = document.getElementById('mb-bundlelist');
    if (!el) return;
    el.innerHTML = (D.bundles || []).map(function (b, i) {
      if (!bundleIds(b).length) return '';
      var on = bundleOn(b) ? ' is-on' : '';
      var sub = b.blurb ? '<small>' + esc(b.blurb) + '</small>' : '';
      return `<button type='button' class='mb-bundle` + on + `'` +
        ` data-bundle='` + i + `'>` +
        `<span class='mb-bundle__t'><b>` + esc(b.name) + '</b>' +
        sub + '</span>' +
        `<span class='mb-bundle__p'>+` + money(bundlePrice(b)) +
        '</span></button>';
    }).join('');
  }
  function toggleBundle(i) {
    var b = (D.bundles || [])[i];
    if (!b) return;
    var ids = bundleIds(b);
    if (bundleOn(b)) {
      S.extras = S.extras.filter(function (id) {
        return ids.indexOf(id) === -1;
      });
    } else {
      ids.forEach(function (id) {
        if (S.extras.indexOf(id) === -1) { S.extras.push(id); S.qty[id] = 1; }
      });
    }
    renderBundles(); renderExtras(); renderParcel(); renderBar();
  }

  /* ---- flavours -------------------------------------------------------
     Tapping the tile is what selects. The information icon opens the
     detail view and nothing else.

     S.flav is a flat list of names, one entry per slice, and the same name
     is allowed to appear more than once - two slices of Chocolate Fudge is
     an ordinary order and used to be impossible to ask for. That makes the
     tile a counter rather than a checkbox on any size that takes more than
     one slice: tapping adds a slice, and the minus in the stepper takes one
     back. On a one-slice cake there is nothing to count, so the tiles behave
     like radio buttons instead and tapping a second flavour swaps it.

     One entry per slice is also exactly the shape addToCart() wants - it
     writes Flavour One / Flavour Two down the list - so a doubled flavour
     reaches the bakery as two lines saying the same thing, which is what a
     two-slice-of-one-flavour cake is. */

  function flavCount(name) {
    var n = 0;
    for (var i = 0; i < S.flav.length; i++) {
      if (S.flav[i] === name) n++;
    }
    return n;
  }

  function renderFlavours() {
    var mx = maxFlav();
    var used = S.flav.length;
    var full = used >= mx;
    $('#mb-flavs').innerHTML = D.flavours.map(function (f, i) {
      var n = flavCount(f.name);
      var on = n > 0;
      /* Dimming means "there is no room for this", which is only true of a
         flavour that is not already on the cake - a chosen one can always be
         taken back off. */
      var dim = !on && full;
      var canZoom = !!(f.img || f.blurb || f.ing);
      /* a span, not a button - a button inside a button is invalid HTML */
      var zoom = '';
      if (canZoom) {
        zoom = `<span class='mb-flav__zoom' role='button' tabindex='0'` +
          ` data-zoom='` + i + `'` +
          ` aria-label='About ` + esc(f.name) + `'>` +
          `<svg viewBox='0 0 24 24' aria-hidden='true'>` +
          `<circle cx='12' cy='12' r='9'/>` +
          `<line x1='12' y1='11' x2='12' y2='16.5'/>` +
          `<line x1='12' y1='7.6' x2='12' y2='8.2'/></svg></span>`;
      }
      /* The stepper is the only way back down, so it appears as soon as the
         flavour is on the cake. Not on a one-slice cake: there is no second
         slice to count and the tiles are a radio group there. */
      var step = '';
      if (on && mx > 1) {
        step = `<span class='mb-qty mb-qty--flav'>` +
          `<span role='button' tabindex='0'` +
          ` data-fqty='-1|` + esc(f.name) + `'` +
          ` aria-label='One fewer ` + esc(f.name) + `'>` + AMP + '#8722;</span>' +
          '<b>' + n + '</b>' +
          `<span role='button' tabindex='0'` +
          ` data-fqty='1|` + esc(f.name) + `'` +
          (full ? ` class='is-off'` : '') +
          ` aria-label='One more ` + esc(f.name) + `'>+</span></span>`;
      }
      return `<button type='button' class='mb-flav` +
        (on ? ' is-on' : '') + (dim ? ' is-dim' : '') + `'` +
        ` aria-pressed='` + (on ? 'true' : 'false') + `'` +
        ` data-flav='` + esc(f.name) + `'>` + zoom +
        (f.img ? `<img class='mb-flav__photo' src='` + esc(f.img) + `' alt='' loading='eager'>` : '') +
        `<span class='mb-flav__tk'>` +
        (n > 1 ? AMP + '#215;' + n : AMP + '#10003;') + '</span>' +
        `<span class='mb-flav__n'>` + esc(f.name) + '</span>' +
        step + '</button>';
    }).join('');
    var fc = $('#mb-fcount');
    /* Says what is still needed rather than only what has been done - this
       is the count the Continue button is now checked against. */
    fc.textContent = full
      ? used + ' of ' + mx + ' chosen'
      : used + ' of ' + mx + ' chosen - ' + (mx - used) + ' to go';
    fc.classList.toggle('is-full', full);
  }

  var zoomEl = document.getElementById('mb-zoom');
  if (zoomEl) root.appendChild(zoomEl);

  /* The detail view is for reading, not choosing - the tile is the action.
     Ingredients and allergens are two folds side by side, both shut. The
     allergen one arrives from Liquid already built, so it goes in as it is. */
  function openZoom(i) {
    var f = D.flavours[i];
    if (!f || !zoomEl) return;
    var img = '';
    if (f.img) {
      img = `<img class='mb-zoom__im'` +
        ` style='aspect-ratio:4/3'` +
        ` src='` + esc(f.img) + `'` +
        ` alt='` + esc(f.name) + `'>`;
    }
    var blurb = f.blurb
      ? `<p class='mb-zoom__blurb'>` + esc(f.blurb) + '</p>'
      : '';
    var ing = f.ing
      ? `<details class='mb-zfold'><summary>` +
        esc(D.ingredients_label || 'Ingredients') + '</summary>' +
        `<div class='mb-zfold__b'>` + f.ing + '</div></details>'
      : '';
    var note = D.allergen || '';
    document.getElementById('mb-zoom-body').innerHTML = img +
      `<div class='mb-zoom__b'><h3>` + esc(f.name) + '</h3>' +
      blurb + ing + note + '</div>';
    zoomEl.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeZoom() {
    if (!zoomEl) return;
    zoomEl.hidden = true;
    document.body.style.overflow = '';
  }

  /* ---- photo ---------------------------------------------------------- */

  function photoError(msg) {
    var e = $('#mb-photo-err');
    if (!e) return;
    if (!msg) { e.hidden = true; e.textContent = ''; return; }
    e.hidden = false; e.textContent = msg;
  }

  function setPhoto(file) {
    photoError('');
    if (!file) return;
    if (String(file.type).indexOf('image/') !== 0) {
      photoError('That does not look like an image. JPG, PNG or WebP please.');
      return;
    }
    if (file.size > D.max_mb * 1024 * 1024) {
      photoError('That photo is ' + (file.size / 1048576).toFixed(1) +
        'MB. The limit is ' + D.max_mb + 'MB - try a smaller copy.');
      return;
    }
    if (S.photoUrl) URL.revokeObjectURL(S.photoUrl);
    S.photo = file;
    S.photoUrl = URL.createObjectURL(file);
    S.face = 'card';
    clearFlag('photo');
    renderPhoto();
    renderMessage();
    $('#mb-err').textContent = '';
  }

  function clearPhoto() {
    if (S.photoUrl) URL.revokeObjectURL(S.photoUrl);
    S.photo = null; S.photoUrl = null;
    var input = $('#mb-photo-in');
    if (input) input.value = '';
    renderPhoto();
    renderMessage();
  }

  function renderPhoto() {
    var wrap = $('#mb-photo');
    if (!wrap) return;
    /* Hidden, not removed. assets/mb-ai-handoff.js finds #mb-photo-in by id
       and injects the finished design into it with DataTransfer; deleting
       the markup would drop the artwork on the floor. */
    wrap.hidden = !D.needs_image || D.is_ai;
    if (!D.needs_image) return;
    var pv = $('#mb-photo-pv'), ph = $('#mb-photo-ph');
    var row = $('#mb-photo-row');
    if (S.photoUrl) {
      pv.src = S.photoUrl; pv.hidden = false;
      ph.hidden = true;
      row.hidden = false;
      $('#mb-photo-name').textContent = S.photo.name + ' · ' +
        (S.photo.size / 1048576).toFixed(1) + 'MB';
    } else {
      pv.hidden = true; pv.removeAttribute('src');
      ph.hidden = false;
      row.hidden = true;
    }
  }

  /* ---- message -------------------------------------------------------- */

  function renderMessage() {
    root.setAttribute("data-message-face", S.face);
    var f = D.fonts.filter(function (x) { return x.id === S.font; })[0];
    var c = D.colours.filter(function (x) { return x.id === S.colour; })[0];
    $('#mb-fonts').innerHTML = D.fonts.map(function (x) {
      return `<button type='button' class='` +
        (S.font === x.id ? 'is-on' : '') + `'` +
        ` data-font='` + esc(x.id) + `'` +
        ` title='` + esc(x.name) + `'` +
        ` style='font-family:` + x.stack + `'>` + esc(x.name) + `</button>`;
    }).join('');
    $('#mb-cols').innerHTML = D.colours.map(function (x) {
      return `<button type='button' class='` +
        (S.colour === x.id ? 'is-on' : '') + `'` +
        ` data-colour='` + esc(x.id) + `'` +
        ` title='` + esc(x.name) + `'` +
        ` style='background:` + x.hex + `'></button>`;
    }).join('');
    var sf = document.getElementById('mb-sum-font');
    if (sf) sf.textContent = f ? f.name : '';
    var sc = document.getElementById('mb-sum-col');
    if (sc) sc.textContent = c ? c.name : '';

    var stage = $('#mb-stage');
    if (S.face === 'card') {
      if (D.needs_image) {
        if (S.photoUrl) {
          stage.innerHTML = `<img src='` + esc(S.photoUrl) + `'` +
            ` alt='Your photo on the front of the card'>`;
        } else if (D.is_ai) {
          /* There is no chooser on this step for an AI card, so pointing at
             one would send the customer looking for a control that is not
             there. Send them back to where the design is actually made. */
          stage.innerHTML = `<div class='mb-stage__prompt'>` +
            'We could not find your design.<br>' +
            'Go back and create it again and it will appear here.</div>';
        } else {
          stage.innerHTML = `<div class='mb-stage__prompt'>` +
            'Your photo goes on the front of this card.<br>' +
            'Choose one on the right and it will appear here.</div>';
        }
      } else {
        stage.innerHTML = D.image
          ? `<img src='` + esc(D.image) + `' alt=''>`
          : '';
      }
    } else {
      var empty = !S.msg.trim();
      var style = 'font-family:' + f.stack + ';text-align:' + S.align + ';font-weight:' + (/ Bold$/.test(f.name) ? '700' : '400') + ';';
      if (S.textSize) style += 'font-size:' + (S.textSize * 4 / 3 * Math.min(stage.clientWidth, stage.clientHeight / 1.414 || 390, 390) / (148.5 * 3.7795)) + 'px;';
      if (!empty) style += 'color:' + c.hex;
      var host = stage.querySelector('.mb-pv__m');
      var card = stage.querySelector('.mb-pv__t');
      var typing = card && document.activeElement === card;
      if (typing && host) {
        /* Never rebuild the card while it is being typed on - replacing the
           innerHTML would take the caret with it. Only the styling can change
           from here, and the text is already what the customer just typed. */
        host.setAttribute('style', style);
        host.classList.toggle('is-empty', empty);
      } else {
        var lg = shopLogo();
        var foot = lg
          ? `<img class='mb-pv__logo' src='` + esc(lg) + `' alt=''>`
          : `<div class='mb-pv__brand'>MailBakes</div>`;
        var ph = S.blank ? BLANK_PH : 'Tap to write your message';
        stage.innerHTML = `<div class='mb-pv'>` +
          `<div class='mb-pv__m` + (empty ? ' is-empty' : '') +
          (S.blank ? ' is-locked' : '') + `'` +
          ` style='` + style + `'>` +
          `<span class='mb-pv__t'` +
          (S.blank ? '' : ` contenteditable='true'`) +
          ` role='textbox' aria-multiline='true' aria-label='Your message'` +
          ` data-ph='` + esc(ph) + `'>` +
          esc(S.blank ? '' : S.msg) + '</span></div>' + foot + '</div>';
      }
    }
    $('#mb-cc').textContent = S.msg.length;
    $$('.mb-flip button').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-face') === S.face);
    });
  }

  /* ---- delivery ------------------------------------------------------- */

  function renderWhen() {
    $('#mb-dates').innerHTML = D.dates.map(function (d) {
      return `<button type='button' class='mb-opt` +
        (S.when === d.id ? ' is-on' : '') + `'` +
        ` data-when='` + esc(d.id) + `'>` +
        `<span class='mb-opt__rd'></span><span>` +
        `<span class='mb-opt__t'>` + esc(d.title) + '</span>' +
        `<span class='mb-opt__d'>` + esc(d.blurb) + '</span></span></button>';
    }).join('');
    var wrap = $('#mb-calwrap');
    wrap.hidden = S.when !== 'pick';
    /* the estimate caveat belongs to Choose a date and nothing else */
    var est = document.getElementById('mb-estim');
    if (est) est.hidden = S.when !== 'pick';
    if (S.when === 'pick') renderCal();
  }

  var calMonth = null;
  function startOfDay(d) {
    var x = new Date(d); x.setHours(0, 0, 0, 0); return x;
  }
  function earliest() {
    var d = startOfDay(new Date(D.today));
    d.setDate(d.getDate() + D.lead_days);
    return d;
  }

  function renderCal() {
    var min = earliest();
    if (!calMonth) calMonth = new Date(min.getFullYear(), min.getMonth(), 1);
    var max = startOfDay(new Date(D.today));
    max.setDate(max.getDate() + 120);
    var y = calMonth.getFullYear(), m = calMonth.getMonth();
    var first = new Date(y, m, 1), days = new Date(y, m + 1, 0).getDate();
    var pad = (first.getDay() + 6) % 7;
    var names = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];
    var prevOk = new Date(y, m, 0) >= min;
    var html = `<div class='mb-cal__h'>` +
      `<button type='button' data-cal='-1'` +
      (prevOk ? '' : ' disabled') + '>' + AMP + 'lsaquo;</button>' +
      '<strong>' + names[m] + ' ' + y + '</strong>' +
      `<button type='button' data-cal='1'>` + AMP + 'rsaquo;</button></div>';
    html += `<div class='mb-cal__dow'>`;
    ['M', 'T', 'W', 'T', 'F', 'S', 'S'].forEach(function (d) {
      html += '<span>' + d + '</span>';
    });
    html += `</div><div class='mb-cal__g'>`;
    for (var i = 0; i < pad; i++) {
      html += `<button type='button' class='mb-cal__pad' disabled></button>`;
    }
    for (var d = 1; d <= days; d++) {
  var dt = new Date(y, m, d);
  var isSunday = dt.getDay() === 0;
  var inRange = dt >= min && dt <= max;

  var iso = dt.getFullYear() + '-' +
    ('0' + (dt.getMonth() + 1)).slice(-2) + '-' +
    ('0' + dt.getDate()).slice(-2);

  html += `<button type='button' data-day='` + iso + `'` +
    (isSunday && inRange
      ? ` data-sunday='true' aria-disabled='true' class='is-sunday'`
      : (S.date === iso ? ` class='is-on'` : '')) +
    (!inRange ? ' disabled' : '') +
    '>' + d + '</button>';
}
   $('#mb-calwrap').innerHTML =
  `<p id='mb-sunday-note' class='mb-sunday-note' aria-live='polite'></p>` +
  `<div class='mb-cal'>` + html + `</div></div>`;
  }

  /* ---- extras ---------------------------------------------------------
     Every extra takes a quantity. The stepper is capped: ops has not
     confirmed the real per-item limit, so the cap is a theme setting
     rather than a number buried in here. */

  function labelFor(title) {
    if (matches(D.best_extras, title)) return { t: 'Best seller', c: '' };
    if (matches(D.new_extras, title)) return { t: 'New', c: ' mb-gift__lb--new' };
    return null;
  }

  /* Per-extra copy comes from the section as a small lookup table rather
     than being welded to variant ids, so it survives a variant being
     rebuilt. Exact title first, then a contains match, same spirit as
     labelFor() above. */
  function infoFor(title) {
    var list = D.extra_info || [];
    var t = String(title || '').trim().toLowerCase();
    var i, m;
    for (i = 0; i < list.length; i++) {
      m = String(list[i].match || '').trim().toLowerCase();
      if (m && m === t) return list[i];
    }
    for (i = 0; i < list.length; i++) {
      m = String(list[i].match || '').trim().toLowerCase();
      if (m && t.indexOf(m) > -1) return list[i];
    }
    return null;
  }

  function renderExtras() {
    $('#mb-gifts').innerHTML = D.extras.map(function (g) {
      var on = S.extras.indexOf(g.id) > -1;
      var lb = labelFor(g.title);
      var badge = lb
        ? `<span class='mb-gift__lb` + lb.c + `'>` + lb.t + '</span>'
        : '';
      /* Only edible extras carry the information icon - an envelope has
         nothing to declare. Same span-not-button trick as the flavours,
         because this one also sits inside a button. */
      var xi = infoFor(g.title);
      var zoom = '';
      if (xi && xi.food) {
        zoom = `<span class='mb-gift__zoom' role='button' tabindex='0'` +
          ` data-xzoom='` + g.id + `'` +
          ` aria-label='About ` + esc(g.title) + `'>` +
          `<svg viewBox='0 0 24 24' aria-hidden='true'>` +
          `<circle cx='12' cy='12' r='9'/>` +
          `<line x1='12' y1='11' x2='12' y2='16.5'/>` +
          `<line x1='12' y1='7.6' x2='12' y2='8.2'/></svg></span>`;
      }
      var pic = g.image
        ? `<img src='` + esc(g.image) + `' alt='' loading='lazy'>`
        : '';
      var n = qtyOf(g.id);
      var step = '';
      if (on) {
        step = `<span class='mb-qty'>` +
          `<span role='button' tabindex='0' data-qty='` + g.id + `:-1'` +
          (n <= 1 ? ` class='is-off'` : '') +
          ` aria-label='One fewer'>` + AMP + '#8722;</span>' +
          '<b>' + n + '</b>' +
          `<span role='button' tabindex='0' data-qty='` + g.id + `:1'` +
          (n >= MAXQ ? ` class='is-off'` : '') +
          ` aria-label='One more'>+</span></span>`;
      }
      return `<button type='button' class='mb-gift` +
        (on ? ' is-on' : '') + `' data-extra='` + g.id + `'>` + badge + zoom +
        `<span class='mb-gift__ad'>` +
        (on ? AMP + '#10003;' : '+') + '</span>' + pic +
        `<div class='mb-gift__n'>` + esc(g.title) + '</div>' +
        `<div class='mb-gift__p'>+` + money(g.price * n) + '</div>' +
        step + '</button>';
    }).join('');
  }

  function bumpQty(id, dir) {
    if (S.extras.indexOf(id) === -1) return;
    var n = qtyOf(id) + dir;
    if (n < 1) {
      S.extras.splice(S.extras.indexOf(id), 1);
      delete S.qty[id];
    } else {
      S.qty[id] = Math.min(MAXQ, n);
    }
    renderExtras(); renderBundles(); renderParcel(); renderBar();
  }

  /* The extras detail view is the flavour one - same #mb-zoom shell, same
     .mb-zoom__im hero, same pair of .mb-zfold folds. Ingredients and
     Allergens are siblings and both start shut; neither is inside the
     other. Unlike the flavours, allergen text is per extra, so the fold is
     built here rather than handed over ready-made by Liquid. */
  function openExtraZoom(id) {
    var g = extraOf(id);
    if (!g || !zoomEl) return;
    var xi = infoFor(g.title) || {};
    var src = xi.img || g.image_big || g.image || '';
    var img = src
      ? `<img class='mb-zoom__im mb-zoom__im--x'` +
        ` src='` + esc(src) + `'` +
        ` alt='` + esc(g.title) + `'>`
      : '';
    var blurb = xi.blurb
      ? `<p class='mb-zoom__blurb'>` + esc(xi.blurb) + '</p>'
      : '';
    var ing = xi.ing
      ? `<details class='mb-zfold'><summary>` +
        esc(D.ingredients_label || 'Ingredients') + '</summary>' +
        `<div class='mb-zfold__b'>` + xi.ing + '</div></details>'
      : '';
    var alg = xi.all
      ? `<details class='mb-zfold mb-zfold--all'><summary>` +
        esc(D.allergen_label || 'Allergens') + '</summary>' +
        `<div class='mb-zfold__b'>` + xi.all + '</div></details>'
      : '';
    document.getElementById('mb-zoom-body').innerHTML = img +
      `<div class='mb-zoom__b'><h3>` + esc(g.title) + '</h3>' +
      blurb + ing + alg + '</div>';
    zoomEl.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  /* ---- chrome --------------------------------------------------------- */

  function renderRail() {
    var idx = RAIL[cur];
    var items = document.querySelectorAll('[data-mb-rail] li');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.toggle('is-on', i === idx);
      items[i].classList.toggle('is-done', i < idx);
    }
    var fill = document.getElementById('mb-pfill');
    if (fill) {
      fill.style.width =
        (((cur - FIRST + 1) / (LAST - FIRST + 2)) * 100) + '%';
    }
  }

  function renderBar() {
    $('#mb-price').textContent = money(total());
    var bits = [sizeOf(S.size).title];
    if (cardQuantity() > 1) bits.unshift('Multi-Card × ' + cardQuantity());
    var units = S.extras.reduce(function (t, id) { return t + qtyOf(id); }, 0);
    if (units) bits.push(units + ' extra' + (units > 1 ? 's' : ''));
    /* Postage is chosen on step 5 and only joins the total from there, so on
       the screens before it the bar would otherwise quote a price the customer
       will not be charged. Say so, quietly, under the number. Keyed off
       postage() rather than the step index: the moment postage is actually in
       the total the note has nothing left to warn about and removes itself. */
    if (!postage() && BASE_POSTAGE > 0) {
      bits.push('plus ' + money(BASE_POSTAGE) + ' postage');
    }
    $('#mb-bar-sub').textContent = bits.join(' · ');
    $('#mb-back').textContent = cur === FIRST ? '← Change design' : 'Back';
    $('#mb-next').textContent = cur === LAST
      ? (S.isEdit
        ? 'Save changes'
        : (S.extras.length
          ? (D.cta_some || 'Continue to basket')
          : (D.cta_none || 'No thanks, continue to basket')))
      : 'Continue →';
    var fmt = isParcel()
      ? (D.parcel_note || '')
      : (D.letterbox_note || '');
    var mids = {
      2: '',
      3: 'Baked the morning it leaves us',
      4: (D.needs_image && !D.is_ai)
        ? 'Your photo on the front, your words inside'
        : 'Printed on the inside of your cake card',
      5: fmt,
      /* The two-to-one-address delivery line used to sit here. Removed at the
         merchant's request - the same claim is still available on the basket
         page, where it can be switched on or off in the theme editor. */
      6: ''
    };
    $('#mb-bar-mid').textContent = mids[cur] || '';
    renderRail();
  }

  /* ---- moving between steps -------------------------------------------
     A step change lands on the new step's own heading, not the top of the
     page: the banner and the stepper are worth walking past once, not five
     times. Their height is measured rather than assumed - it differs on a
     phone, and either can be turned off in the editor - and only chrome
     that actually sticks to the top can hide anything. */

  var STICKY = ['.mbh', '.mbh__ann', '.mb-rail'];

  function chromeHeight() {
    var seen = [];
    var h = 0;
    STICKY.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') return;
      /* a sticky parent already covers whatever sits inside it */
      for (var i = 0; i < seen.length; i++) {
        if (seen[i].contains(el)) return;
      }
      var box = el.getBoundingClientRect();
      if (box.height <= 0) return;
      seen.push(el);
      h += box.height;
    });
    return h;
  }

  function scrollToStep() {
    var el = root.querySelector('.mb-screen.is-on');
    if (!el) return;
    var y = el.getBoundingClientRect().top + (window.pageYOffset || 0) -
      chromeHeight() - 8;
    if (y < 0) y = 0;
    var still = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({ top: y, behavior: still ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, y);   /* older Safari has no options object */
    }
  }

  /* Only a step change moves the page. On first paint the browser is already
     where it should be, and hauling it down would hide the way out. */
  function showStep(move) {
    $$('.mb-screen').forEach(function (e) {
      e.classList.toggle('is-on', +e.getAttribute('data-step') === cur);
    });
    $('#mb-err').textContent = '';
    renderBar();
    if (move) scrollToStep();
  }

  function renderAll() {
    renderGallery(); renderSizes(); renderBundles(); renderFlavours();
    renderPhoto(); renderMessage(); renderWhen(); renderExtras();
    renderParcel(); renderBar();
  }

  function validate() {
    /* The cake has a fixed number of slices and every one of them is baked
       to a flavour, so "at least one" was never the rule - it just happened
       to be what was checked, and a two-slice cake could be sent to the
       basket with one flavour on it and nothing said. The size decides the
       number; the step is done when the count matches it. */
    if (cur === 4 && S.mediaBusy) return 'Please wait for your recording to finish uploading.';
    if (cur === 4 && !S.blank) {
      var text = root.querySelector('.mb-pv__t'), host = root.querySelector('.mb-pv__m');
      if (text && host && text.getBoundingClientRect().height > host.clientHeight + 2) return 'Your message needs more room. Choose a smaller text size or shorten it slightly.';
    }
    if (cur === 3) {
      var need = maxFlav();
      var left = need - S.flav.length;
      if (left > 0) {
        if (need === 1) return 'Pick a flavour to carry on.';
        return S.flav.length === 0
          ? 'Pick ' + need + ' flavours to carry on - one for each slice.'
          : left + ' more ' + (left === 1 ? 'flavour' : 'flavours') +
            ' to go - this size takes ' + need + '.';
      }
    }
    if (cur === 4 && D.needs_image && !S.photo) {
      /* a cart line holds a file reference, not the file - it has to come back.
         Still enforced for AI cards even though their panel is hidden: the
         handoff can fail (design older than an hour, private browsing, or a
         basket edit, which deletes and re-adds the line without the image),
         and without this a photo card would check out with no artwork and
         nothing anywhere to say so. */
      if (D.is_ai) {
        return 'We could not find your design - go back and create it again.';
      }
      return S.isEdit
        ? 'Please add the photo again - we cannot carry it over from your basket.'
        : 'Add the photo that goes on the front of the card.';
    }
    /* Blank is a deliberate choice, not an oversight: the tick box says so in
       as many words, so it is the one way past this. */
    if (cur === 4 && !S.blank && !S.msg.trim()) {
      return 'Add a message, or tick "leave the message blank" to send it without one.';
    }
    if (cur === 5 && S.when === 'pick' && !S.date) {
      return 'Choose a date from the calendar.';
    }
    return null;
  }

  function step(dir) {
    closeZoom();
    if (dir > 0) {
      var err = validate();
      if (err) { $('#mb-err').textContent = err; return; }
      leaving(cur);
      if (cur === LAST) { addToCart(); return; }
    }
    if (dir < 0 && cur === FIRST) { history.back(); return; }
    cur = Math.max(FIRST, Math.min(LAST, cur + dir));
    showStep(true);
    touched = true;
    removeResume();
    persist();
  }

  function readErr(r) {
    return r.json().catch(function () { return {}; }).then(function (j) {
      throw new Error(j.description || j.message ||
        'Could not add to basket');
    });
  }

  function addMain(props) {
    if (!S.photo) {
      return fetch(D.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: D.variant_id, quantity: 1, properties: props }]
        })
      }).then(function (r) { return r.ok ? r.json() : readErr(r); });
    }
    var fd = new FormData();
    fd.append('id', D.variant_id);
    fd.append('quantity', '1');
    Object.keys(props).forEach(function (k) {
      fd.append('properties[' + k + ']', props[k]);
    });
    fd.append('properties[' + D.image_property + ']', S.photo, S.photo.name);
    return fetch(D.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    }).then(function (r) { return r.ok ? r.json() : readErr(r); });
  }

  function addRest(items) {
    if (!items.length) return Promise.resolve();
    return fetch(D.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.ok ? r.json() : readErr(r); });
  }

  /* ---- edit mode ------------------------------------------------------
     The basket links back with ?mb_edit=<line key>. Everything the flow
     needs is already on that line as a property, so state is rebuilt from
     the cart rather than from anything we keep on our side. A stale key
     just falls through to a normal new cake. */

  function editKeyFromUrl() {
    var parts = String(window.location.search || '').slice(1).split('&');
    for (var i = 0; i < parts.length; i++) {
      var kv = parts[i].split('=');
      if (decodeURIComponent(kv[0]) === 'mb_edit') {
        return decodeURIComponent(String(kv[1] || '').replace(/\+/g, ' '));
      }
    }
    return null;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  function byName(list, name) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].name === name) return list[i];
    }
    return null;
  }

  /* the slice upgrade rides the same group id as the extras do */
  function isSizeVariant(vid) {
    for (var i = 0; i < D.sizes.length; i++) {
      if (String(D.sizes[i].variant_id) === String(vid)) return true;
    }
    return false;
  }

  function restore(line, items) {
    var p = line.properties || {};
    S.shippingProperties = {};
    Object.keys(p).forEach(function (key) {
      if (key.indexOf('Shipping ') === 0) S.shippingProperties[key] = p[key];
    });
    var i;

    for (i = 0; i < D.sizes.length; i++) {
      if (D.sizes[i].title === p['One or Two Slices']) {
        S.size = D.sizes[i].id;
        break;
      }
    }

    var words = ['One', 'Two', 'Three', 'Four'];
    var flav = [];
    for (i = 0; i < words.length; i++) {
      var nm = p['Flavour ' + words[i]];
      /* Repeats are kept. A basket line reading Chocolate Fudge twice is a
         cake with two slices of it, and de-duplicating on the way back in
         would quietly halve the order the moment it was edited. */
      if (nm && byName(D.flavours, nm)) {
        flav.push(nm);
      }
    }
    S.flav = flav.slice(0, maxFlav());

    S.align = ['left','center','right'].indexOf(p['Message Alignment']) >= 0 ? p['Message Alignment'] : 'center';
    S.textSize = [12,14,16,18,20,24,28,32,36].indexOf(Number(p['Message Size'])) >= 0 ? Number(p['Message Size']) : 0;
    S.video = /^[a-f0-9]{48}$/.test(p['_mb_message_video'] || '') ? p['_mb_message_video'] : null;
    S.audio = /^[a-f0-9]{48}$/.test(p['_mb_message_audio'] || '') ? p['_mb_message_audio'] : null;
    S.msg = p['Personalised Message'] || '';
    S.blank = !S.msg;
    var blankInput = document.getElementById('mb-blank');
    if (blankInput) blankInput.checked = S.blank;
    /* open on the words they wrote - photo cards still lead with the front */
    if (!D.needs_image || D.is_ai) S.face = 'msg';
    /* the line stores the name, not the id we key the pickers on */
    var f = byName(D.fonts, p['Message Font']);
    if (f) S.font = f.id;
    var c = byName(D.colours, p['Message Colour']);
    if (c) S.colour = c.id;

    if (p['Pre-Order'] === D.later_label) {
      S.when = 'pick';
      var dmy = String(p['Target Delivery Date'] || '').split('-');
      if (dmy.length === 3) S.date = dmy[2] + '-' + dmy[1] + '-' + dmy[0];
    } else {
      S.when = 'asap';
      S.date = null;
    }

    S.extras = [];
    S.qty = {};
    var group = p['_mb_group'] || null;
    if (group) {
      items.forEach(function (it) {
        var ip = it.properties || {};
        if (ip['_mb_parent_group'] !== group) return;
        if (isSizeVariant(it.variant_id)) return;
        var e = extraOf(parseInt(it.variant_id, 10));
        if (!e) return;
        S.extras.push(e.id);
        S.qty[e.id] = Math.max(1, Math.min(MAXQ, parseInt(it.quantity, 10) || 1));
      });
    }

    S.isEdit = true;
    S.editKey = line.key;
    S.editGroup = group;
  }

  function bootEdit() {
    var key = editKeyFromUrl();
    if (!key) return Promise.resolve(false);
    return getCart().then(function (cart) {
      if (!cart || !cart.items) return false;
      var line = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) { line = cart.items[i]; break; }
      }
      if (!line) return false;
      restore(line, cart.items);
      /* the textarea is never redrawn, so state alone leaves it looking
         empty. Filled once here - doing it per render fights the caret. */
      var box = $('#mb-msg');
      if (box) box.value = S.msg;
      renderAll();
      cur = FIRST;
      showStep();
      return true;
    }).catch(function () { return false; });
  }

  /* Saving is add-then-remove, never the other way round: a failed add has
     to leave the basket exactly as the shopper left it. */

  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function removeOld() {
    if (!S.isEdit || !S.editKey) return Promise.resolve();
    return getCart().then(function (cart) {
      var keys = [S.editKey];
      if (cart && cart.items && S.editGroup) {
        cart.items.forEach(function (it) {
          var ip = it.properties || {};
          if (ip['_mb_parent_group'] === S.editGroup &&
            keys.indexOf(it.key) === -1) keys.push(it.key);
        });
      }
      /* one at a time - every change re-reads the basket server side */
      return keys.reduce(function (chain, k) {
        return chain.then(function () { return removeLine(k); });
      }, Promise.resolve());
    }).catch(function () {
      /* the new lines are already in, so a failed tidy-up must not block */
    });
  }

  /* ---- recoverable card -------------------------------------------------
     Sept 2026. Three things hang off this block and nothing else in the
     file knows about them:

       1. Events on document, for assets/mb-klaviyo-flow.js and anything
          else that wants to listen:
            mb:flow:step      a step was completed - validation passed and
                              the customer moved on
            mb:flow:added     the card landed in the basket
            mb:flow:restored  the flow was rebuilt from a link, or from this
                              device's memory
       2. The restore link: the product URL plus ?config=..., written by
          assets/mb-config-link.js (the shared spec - the same file must ship
          in every theme that carries the flow). It goes on every event, on
          the card line as _mb_restore_url, and on the cart as the
          mb_restore_url attribute once the add has succeeded.
       3. Same-device memory in localStorage, saved on every change and
          offered back as "Continue where you left off".

     Step numbers in the events are the spec's, not the screen numbers:
       screen 2 -> step 1 cake        screen 5 -> step 4 delivery_date
       screen 3 -> step 2 flavours                and step 5 postage
       screen 4 -> step 3 message     screen 6 -> step 6 extras
     The delivery screen is two steps because mb-flow-revisions.js splits it
     into "when" and "how it travels". The when half is watched through the
     data-mbfr-sub attribute that layer stamps, and leaving the screen
     forwards completes both; the Klaviyo listener de-duplicates.

     The message travels inside the link (v2, capped at the configurator's
     own character limit, trimmed further only if the URL would pass 2000
     characters, in which case the link says so and the message step asks
     the customer to check it). It is never a named property on a Klaviyo
     event - it reaches Klaviyo only as part of restore_url. */

  var LINK = window.MBConfigLink || null;
  var STEP_NAMES = { 1: 'cake', 2: 'flavours', 3: 'message',
    4: 'delivery_date', 5: 'postage', 6: 'extras' };
  var doneStep = 0;
  var restoredFrom = null;
  var pendingPostage = null;
  var lineKey = null;
  var persistTimer = null;
  var touched = false;   /* the customer has done something on this visit */

  function productInfo() {
    var p = D.product || {};
    return {
      id: p.id || null,
      handle: p.handle || '',
      title: p.title || '',
      url: window.location.origin + (p.url || window.location.pathname),
      image_url: D.image || null,
      price: D.base / 100,
      collections: p.collections || []
    };
  }

  function postageEl() { return document.querySelector('[data-ship].is-on'); }
  function postageTitle(el) {
    var t = el && el.querySelector('.mb-opt__t');
    if (!t) return null;
    var n = t.firstChild;
    return (n && n.nodeType === 3)
      ? String(n.nodeValue).trim()
      : String(t.textContent).trim();
  }

  /* the v2 link object - see assets/mb-config-link.js for the key list */
  function flowConfig() {
    var c = { v: 2, s: S.size, f: S.flav.slice(), fo: S.font, c: S.colour,
      w: S.when, st: doneStep, q: cardQuantity(), al: S.align, ts: S.textSize, vi: S.video, au: S.audio };
    if (S.when === 'pick' && S.date) c.d = S.date;
    if (S.blank) c.b = 1;
    else if (S.msg) c.m = String(S.msg);
    if (S.extras.length) {
      c.x = {};
      S.extras.forEach(function (id) { c.x[id] = qtyOf(id); });
    }
    var p = postageEl();
    if (p) c.p = p.getAttribute('data-ship');
    return c;
  }

  function restoreUrl(key) {
    if (!LINK) return '';
    return LINK.build(productInfo().url, flowConfig(), key ? { mb_edit: key } : null);
  }

  /* the non-sensitive selections, in words - what the events carry */
  function flowSummary() {
    var sz = sizeOf(S.size);
    var p = postageEl();
    var pp = p ? parseInt(p.getAttribute('data-ship-price'), 10) : 0;
    var units = S.extras.reduce(function (t, id) { return t + qtyOf(id); }, 0);
    return {
      card_quantity: cardQuantity(),
      size: sz.title,
      slice_count: sz.slices,
      flavours: S.flav.slice(),
      delivery_when: S.when === 'pick' ? 'date' : 'asap',
      delivery_date: (S.when === 'pick' && S.date) ? S.date : null,
      postage: postageTitle(p),
      postage_price: pp > 0 ? pp / 100 : null,
      extras: S.extras.map(function (id) {
        var e = extraOf(id);
        return e ? { title: e.title, quantity: qtyOf(id), price: e.price / 100 } : null;
      }).filter(Boolean),
      extras_count: units,
      total: total() / 100
    };
  }

  function emit(name, detail) {
    var ev;
    try {
      ev = new CustomEvent(name, { detail: detail });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(name, false, false, detail);
    }
    document.dispatchEvent(ev);
  }

  function eventDetail(extra) {
    var d = {
      product: productInfo(),
      summary: flowSummary(),
      config: flowConfig(),
      restore_url: restoreUrl(),
      restored_from: restoredFrom
    };
    for (var k in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, k)) d[k] = extra[k];
    }
    return d;
  }

  function completed(n) {
    if (n > doneStep) doneStep = n;
    emit('mb:flow:step', eventDetail({ step_number: n, step_name: STEP_NAMES[n] }));
  }

  /* validation has passed and the customer is leaving `screen` forwards */
  function leaving(screen) {
    if (screen === 5) { completed(4); completed(5); }
    else if (screen === 6) { completed(6); }
    else { completed(screen - 1); }
  }

  /* Only after the customer has acted. mb-delivery.js announces postage the
     moment its product loads, and saving on that would overwrite a card this
     device remembers with a blank one before the customer has even been
     offered it. The offer itself also protects the saved card: nothing is
     written while it is on screen. */
  function persist() {
    if (!LINK || S.isEdit || !D.product) return;
    if (!touched || document.getElementById('mb-resume')) return;
    LINK.save(D.product.handle, flowConfig(), cur);
  }
  function schedulePersist() {
    clearTimeout(persistTimer);
    persistTimer = setTimeout(persist, 150);
  }

  function byId(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return list[i];
    }
    return null;
  }

  function validDate(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
    if (!m) return false;
    var dt = new Date(+m[1], +m[2] - 1, +m[3]);
    if (isNaN(dt.getTime()) || dt.getDay() === 0) return false;
    var max = startOfDay(new Date(D.today));
    max.setDate(max.getDate() + 120);
    return dt >= earliest() && dt <= max;
  }

  /* Rebuilds S from a link object. Every id is checked against what this
     product offers today; anything that no longer fits is dropped and the
     step it belongs to is flagged, so the customer is told rather than
     surprised. Returns the flags. */
  function applyConfig(c, source) {
    var flags = [];
    if (!c || typeof c !== 'object') return flags;

    root.setAttribute('data-mb-card-quantity', String(Math.max(1, Math.min(10, parseInt(c.q, 10) || 1))));
    var sz = byId(D.sizes, c.s);
    if (sz) S.size = sz.id;

    var want = Array.isArray(c.f) ? c.f : [];
    S.flav = want.filter(function (n) { return !!byName(D.flavours, n); })
      .slice(0, maxFlav());
    if (S.flav.length < want.length) flags.push('flavours');

    var f = c.fo ? byId(D.fonts, c.fo) : null;
    if (f) S.font = f.id;
    var col = c.c ? byId(D.colours, c.c) : null;
    if (col) S.colour = col.id;

    S.align = ['left','center','right'].indexOf(c.al) >= 0 ? c.al : 'center';
    S.textSize = [12,14,16,18,20,24,28,32,36].indexOf(Number(c.ts)) >= 0 ? Number(c.ts) : 0;
    S.video = /^[a-f0-9]{48}$/.test(c.vi || '') ? c.vi : null;
    S.audio = /^[a-f0-9]{48}$/.test(c.au || '') ? c.au : null;
    S.blank = !!c.b;
    if (S.blank) {
      S.msg = '';
    } else if (typeof c.m === 'string' && c.m) {
      S.msg = c.m;
      /* the link had to shorten it to stay under the URL limit */
      if (c.mt) flags.push('message_trunc');
    } else {
      S.msg = '';
      if (source === 'url') flags.push('message');
    }
    var box = $('#mb-msg');
    if (box) box.value = S.msg;
    var bb = document.getElementById('mb-blank');
    if (bb) bb.checked = S.blank;
    if (!D.needs_image || D.is_ai) S.face = 'msg';

    S.when = c.w === 'pick' ? 'pick' : 'asap';
    S.date = null;
    if (S.when === 'pick') {
      if (validDate(c.d)) {
        S.date = c.d;
        var dp = c.d.split('-');
        calMonth = new Date(+dp[0], +dp[1] - 1, 1);
      } else {
        flags.push('date');
      }
    }

    S.extras = []; S.qty = {};
    if (c.x && typeof c.x === 'object') {
      Object.keys(c.x).forEach(function (k) {
        var id = parseInt(k, 10);
        if (!extraOf(id)) { flags.push('extras'); return; }
        S.extras.push(id);
        S.qty[id] = Math.max(1, Math.min(MAXQ, parseInt(c.x[k], 10) || 1));
      });
    }

    /* the AI handoff may already have put the design back before a link
       restore lands (the basket check it waits on is asynchronous) */
    if (D.needs_image && !S.photo) flags.push('photo');
    pendingPostage = c.p ? String(c.p) : null;
    doneStep = Math.max(0, Math.min(6, parseInt(c.st, 10) || 0));
    return flags;
  }

  /* The postage picker arrives whenever /products/mb-delivery.js does, so the
     saved service is applied the moment its button exists - now, or on the
     mb:postage event mb-delivery.js fires once it has mounted. A click, not
     a state write: mb-delivery.js owns that state. */
  function applyPostage() {
    if (!pendingPostage) return;
    var tryIt = function () {
      var b = document.querySelector('[data-ship="' + pendingPostage + '"]');
      if (!b) return false;
      if (!b.classList.contains('is-on')) b.click();
      pendingPostage = null;
      return true;
    };
    if (tryIt()) return;
    var h = function () {
      if (tryIt()) document.removeEventListener('mb:postage', h);
    };
    document.addEventListener('mb:postage', h);
  }

  function firstIncomplete() {
    var saved = cur, land = LAST;
    for (var s = FIRST; s <= LAST; s++) {
      cur = s;
      if (validate()) { land = s; break; }
    }
    cur = saved;
    return land;
  }

  var FLAG_COPY = {
    message: { screen: 4, text: 'Welcome back - please type your message again. It could not be carried in this link.' },
    message_trunc: { screen: 4, text: 'Your message was too long to travel in full. Please check it and add anything missing.' },
    photo: { screen: 4, text: 'Please add your photo again - photos cannot be carried over.' },
    date: { screen: 5, text: 'The delivery date you picked is no longer available. Please choose another.' },
    flavours: { screen: 3, text: 'One of your flavours is no longer available - please check your choices.' },
    extras: { screen: 6, text: 'One of your extras is no longer available - please check your choices.' }
  };

  function showFlags(flags) {
    var seen = {};
    flags.forEach(function (fl) {
      var c = FLAG_COPY[fl];
      if (!c || seen[fl]) return;
      seen[fl] = true;
      var wrap = root.querySelector('.mb-screen[data-step="' + c.screen + '"] .mb-wrap');
      if (!wrap) return;
      var p = document.createElement('p');
      p.className = 'mb-restore-note';
      p.setAttribute('role', 'status');
      p.setAttribute('data-flag', fl);
      /* an AI card's artwork is made on the Create Your Own page, not
         uploaded here, so the way back is different */
      p.textContent = (fl === 'photo' && D.is_ai)
        ? 'Your design could not be carried over. Go back and create it again and it will appear here.'
        : c.text;
      wrap.insertBefore(p, wrap.firstChild);
    });
  }

  /* the photo note has done its job the moment a photo arrives - including
     the one mb-ai-handoff.js injects a beat after the page has restored */
  function clearFlag(fl) {
    var el = root.querySelector('.mb-restore-note[data-flag="' + fl + '"]');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  /* Land on the screen after the last one they finished, unless something
     earlier no longer validates - a dropped flavour, a missing message, a
     photo - in which case that screen comes first. Never straight to the
     basket: the extras screen is the furthest a link can take anyone. */
  function landAfterRestore(flags, source) {
    var next = doneStep <= 3 ? doneStep + 2 : (doneStep === 4 ? 5 : 6);
    cur = Math.max(FIRST, Math.min(LAST, next, firstIncomplete()));
    restoredFrom = source;
    touched = true;
    root.setAttribute('data-mb-restored', (D.product && D.product.handle) || source);
    renderAll();
    /* renderAll() redraws the design gallery from the product's own images;
       an AI card that already has its artwork gets it back, the same way
       mb-ai-handoff.js showed it in the first place */
    if (D.is_ai && S.photoUrl) {
      var gal = document.getElementById('mb-gal');
      var gimgs = gal ? gal.getElementsByTagName('img') : [];
      if (gimgs.length) {
        gimgs[0].src = S.photoUrl;
        gimgs[0].alt = 'The card you designed';
        gimgs[0].className = (gimgs[0].className + ' is-on').trim();
        while (gimgs.length > 1) { var ex = gimgs[gimgs.length - 1]; (ex.parentNode || gal).removeChild(ex); }
        var dots = gal.querySelector('.mb-gal__dots'); if (dots) dots.parentNode.removeChild(dots);
        var arrows = gal.querySelectorAll('.mb-gal__a'); for (var ai = 0; ai < arrows.length; ai++) arrows[ai].parentNode.removeChild(arrows[ai]);
      }
    }
    showStep(true);
    showFlags(flags);
    applyPostage();
    emit('mb:flow:restored', eventDetail({ source: source, flags: flags, screen: cur }));
    persist();
  }

  function removeResume() {
    var el = document.getElementById('mb-resume');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function offerResume(saved) {
    var wrap = root.querySelector('.mb-screen[data-step="2"] .mb-wrap');
    if (!wrap || document.getElementById('mb-resume')) return;
    var box = document.createElement('div');
    box.className = 'mb-resume';
    box.id = 'mb-resume';
    box.innerHTML = '<div class="mb-resume__t"><b>Continue where you left off?</b>' +
      '<span>You started this card earlier - your choices are still here.</span></div>' +
      '<div class="mb-resume__b">' +
      '<button type="button" class="mb-btn" id="mb-resume-yes">Continue</button>' +
      '<button type="button" class="mb-btn mb-btn--ghost" id="mb-resume-no">Start again</button>' +
      '</div>';
    wrap.insertBefore(box, wrap.firstChild);
    box.addEventListener('click', function (e) {
      if (e.target.closest('#mb-resume-yes')) {
        removeResume();
        landAfterRestore(applyConfig(saved.cfg, 'local'), 'local');
      } else if (e.target.closest('#mb-resume-no')) {
        removeResume();
        if (LINK) LINK.clear(D.product.handle);
      }
    });
  }

  function bootConfig() {
    if (!LINK || !D.product) return;
    var raw = LINK.rawParam(window.location.search, LINK.PARAM);
    var saved = LINK.load(D.product.handle);
    var usedKey = 'mb_cfg_used:' + D.product.handle;
    var used = null;
    try { used = window.sessionStorage.getItem(usedKey); } catch (e) { }

    if (raw && used === raw && saved) {
      /* the link was already opened in this tab; a reload carries on from
         where the tab got to, not from where the link started */
      landAfterRestore(applyConfig(saved.cfg, 'local'), 'local');
      return;
    }
    var fromUrl = raw ? LINK.decode(raw) : null;
    if (fromUrl) {
      if (!fromUrl.m && !fromUrl.b && saved && saved.cfg && typeof saved.cfg.m === 'string') {
        fromUrl.m = saved.cfg.m;   /* link without the words, same device: memory has them */
        delete fromUrl.mt;
      }
      try { window.sessionStorage.setItem(usedKey, raw); } catch (e) { }
      landAfterRestore(applyConfig(fromUrl, 'url'), 'url');
      return;
    }
    if (saved && saved.cfg && (saved.cfg.st >= 1 || typeof saved.cfg.m === 'string')) {
      offerResume(saved);
    }
  }

  function noteLineKey(res) {
    var it = res && res.items ? res.items[0] : res;
    if (it && it.key && String(it.variant_id) === String(D.variant_id)) lineKey = it.key;
  }

  /* After the basket has the card: tell the listeners, forget the device
     copy, and put the link on the cart so it reaches the checkout data.
     Nothing here may stop the customer reaching the basket, so every
     failure is swallowed. */
  function afterAdd() {
    var url = restoreUrl(lineKey);
    try {
      emit('mb:flow:added', eventDetail({ restore_url: url, cart_line_key: lineKey }));
    } catch (e) { }
    if (LINK && D.product) LINK.clear(D.product.handle);
    if (!url) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { mb_restore_url: url } })
    }).catch(function () { });
  }

  function wireRecovery() {
    if (!document.getElementById('mb-restore-css')) {
      var css = document.createElement('style');
      css.id = 'mb-restore-css';
      css.textContent = [
        '.mb-resume{display:flex;flex-wrap:wrap;align-items:center;gap:12px 18px;',
        'margin:0 0 18px;padding:14px 16px;background:#fff;',
        'border:1px solid var(--mb-line,#EDE6E9);border-radius:12px;',
        'box-shadow:0 4px 16px rgba(30,26,28,.06)}',
        '.mb-resume__t{flex:1 1 220px;display:grid;gap:2px;font-size:14.5px;',
        'color:var(--mb-ink,#1E1A1C)}',
        '.mb-resume__t span{color:var(--mb-ink-60,#6E666A);font-size:13.5px}',
        '.mb-resume__b{display:flex;gap:8px;flex-wrap:wrap}',
        '.mb-resume .mb-btn{padding:9px 16px;font-size:14px}',
        '.mb-restore-note{margin:0 0 14px;padding:11px 14px;border-radius:10px;',
        'font-size:14px;background:var(--mb-pink-pale,#F8C6DC);',
        'color:var(--mb-ink,#1E1A1C)}'
      ].join('');
      document.head.appendChild(css);
    }

    /* the when half of the delivery screen is completed inside the revisions
       layer, which stamps data-mbfr-sub="travel" once the date validates */
    var wrap = root.querySelector('.mb-screen[data-step="5"] .mb-dwrap');
    if (wrap && typeof MutationObserver === 'function') {
      var last = wrap.getAttribute('data-mbfr-sub');
      new MutationObserver(function () {
        var now = wrap.getAttribute('data-mbfr-sub');
        if (now === 'travel' && last === 'when' && cur === 5) completed(4);
        last = now;
      }).observe(wrap, { attributes: true, attributeFilter: ['data-mbfr-sub'] });
    }

    /* registered after the flow's own handlers, so state has already moved
       by the time these run */
    var userTouch = function () { touched = true; schedulePersist(); };
    root.addEventListener('click', userTouch);
    root.addEventListener('input', userTouch);
    root.addEventListener('change', userTouch);
    document.addEventListener('mb:postage', schedulePersist);
  }

  function addToCart() {
    var recipients = root.mbGetRecipients ? root.mbGetRecipients() : null;
    if (recipients === false) { $('#mb-err').textContent = 'Please complete the delivery address for every card.'; return; }
    var btn = $('#mb-next');
    btn.disabled = true;
    btn.textContent = S.photo ? 'Uploading…' : 'Adding…';

    var group = 'mb_' + Date.now() + '_' + Math.floor(Math.random() * 1e6);
    var sz = sizeOf(S.size);
    var words = ['One', 'Two', 'Three', 'Four'];

    var props = {};
    Object.keys(S.shippingProperties || {}).forEach(function (key) { props[key] = S.shippingProperties[key]; });
    props['One or Two Slices'] = sz.title;
    S.flav.forEach(function (f, i) {
      props['Flavour ' + (words[i] || i + 1)] = f;
    });
    props['Personalised Message'] = S.blank ? '' : S.msg.trim();
    props['Message Font'] = (D.fonts.filter(function (x) {
      return x.id === S.font;
    })[0] || {}).name;
    props['Message Colour'] = (D.colours.filter(function (x) {
      return x.id === S.colour;
    })[0] || {}).name;
    props['Message Alignment'] = S.align;
    if(S.textSize) props['Message Size'] = String(S.textSize);
    if(S.video) props['_mb_message_video'] = S.video;
    if(S.audio) props['_mb_message_audio'] = S.audio;
    props['Pre-Order'] = S.when === 'asap' ? D.asap_label : D.later_label;
    if (S.when === 'pick' && S.date) {
      var p = S.date.split('-');
      props['Target Delivery Date'] = p[2] + '-' + p[1] + '-' + p[0];
    }
    props['Delivery Format'] = isParcel() ? 'Parcel' : 'Letterbox';
    props['_mb_group'] = group;
    var rurl = restoreUrl();
    if (rurl) props['_mb_restore_url'] = rurl;

    var rest = [];
    if (sz.variant_id) {
      rest.push({
        id: sz.variant_id,
        quantity: 1,
        properties: { '_mb_parent_group': group }
      });
    }
    S.extras.forEach(function (id) {
      var e = extraOf(id);
      if (e) {
        rest.push({
          id: e.id,
          quantity: qtyOf(id),
          properties: { '_mb_parent_group': group }
        });
      }
    });

    /* ONE request, not two.
       -------------------------------------------------------------------
       This used to be addMain() then addRest(), i.e. two back-to-back POSTs
       to /cart/add.js: the card in the first, the slice upgrade and every
       extra in the second. When the second call failed the first had already
       succeeded, so the customer ended up with a card in the basket recording
       "Two Slices" and nothing charging them for it. Silent, because the
       basket prints the slice count from the CARD's own property - the line
       looks correct with the money missing.

       Measured 16-17 Aug 2026: 14 of 163 chargeable choices lost their slice
       line, 8.6%, £79.67 in a day and a half. All 14 kept their postage,
       which is only ever attached on the cart page - so every one of those
       customers reached the basket with the card present and the charge
       gone. Not one order in 196 ever showed extras present with the slice
       missing, so the second call was failing as a unit rather than dropping
       individual items.

       Sending everything in a single items[] array removes the second call
       entirely, so there is no longer a request that can fail on its own
       after the card is already committed. /cart/add.js is all-or-nothing
       within one request, which is what we want here: either the whole cake
       lands or none of it does and the customer is told.

       The photo path still has to POST twice - multipart carries one file
       per add - so it keeps addRest(), and the repair pass in
       mb-slice-upsell.js is the backstop for it. */
    var single = [{ id: D.variant_id, quantity: 1, properties: props }].concat(rest);

    var newGroups = [];
    var addAll;
    if (recipients) {
      var packs = recipients.map(function (address, i) {
        var packGroup = group + '_' + i;
        newGroups.push(packGroup);
        var cardProps = Object.assign({}, props, address, {
          _mb_group: packGroup, _mb_multi_batch: group,
          _mb_multi_quantity: String(recipients.length),
          _mb_separate_address: '1', 'Multi-Card Recipient': 'Card ' + (i + 1) + ' of ' + recipients.length
        });
        // Each recipient can edit their own card from the basket.
        delete cardProps._mb_restore_url;
        var children = rest.filter(function (item) { return i === 0 || String(item.id) === String(sz.variant_id); })
          .map(function (item) { return Object.assign({}, item, { properties: Object.assign({}, item.properties, { _mb_parent_group: packGroup }) }); });
        return { props: cardProps, children: children };
      });
      if (S.photo) {
        // Multipart can upload one card at a time. Keep each upload and its children together.
        addAll = packs.reduce(function (chain, pack) {
          return chain.then(function () { return addMain(pack.props); }).then(function (r) {
            noteLineKey(r); return addRest(pack.children);
          });
        }, Promise.resolve());
      } else {
        var all = [];
        packs.forEach(function (pack) { all.push({ id: D.variant_id, quantity: 1, properties: pack.props }); all = all.concat(pack.children); });
        addAll = addRest(all).then(function (r) { noteLineKey(r); return r; });
      }
      addAll = addAll.catch(function (error) {
        // Remove only this attempt if any upload or charge fails; existing basket items stay intact.
        return getCart().then(function (cart) {
          var keys = (cart && cart.items || []).filter(function (it) {
            var p = it.properties || {}; return newGroups.indexOf(p._mb_group || p._mb_parent_group) !== -1;
          }).map(function (it) { return it.key; });
          return keys.reduce(function (chain, key) { return chain.then(function () { return removeLine(key); }); }, Promise.resolve());
        }).then(function () { throw error; });
      });
    } else {
      addAll = S.photo
        ? addMain(props).then(function (r) { noteLineKey(r); return addRest(rest); })
        : addRest(single).then(function (r) { noteLineKey(r); return r; });
    }

    addAll
      .then(function () { return afterAdd(); })
      .then(function () { return removeOld(); })
      .then(function () { window.location.href = D.cart_url; })
      .catch(function (e) {
        $('#mb-err').textContent = e.message + ' - please try again.';
        btn.disabled = false;
        renderBar();
      });
  }

  /* Tapping the tile. On a one-slice cake the tiles are a radio group, so a
     tap either chooses that flavour or clears it. On anything larger a tap
     adds a slice of it - including a second slice of one already chosen -
     until the cake is full, and the stepper is how a slice comes back off.

     A tap on a full cake used to do nothing at all, silently. It says why
     now, in the same place every other blocked action speaks from. */
  function pickFlavour(name) {
    var mx = maxFlav();
    if (mx === 1) {
      S.flav = S.flav[0] === name ? [] : [name];
    } else if (S.flav.length < mx) {
      S.flav.push(name);
    } else {
      $('#mb-err').textContent = 'That is all ' + mx +
        ' slices chosen. Use the minus on a flavour to swap one out.';
      return;
    }
    renderFlavours();
    $('#mb-err').textContent = '';
  }

  /* The stepper on a chosen flavour. Down to nothing takes it off the cake. */
  function bumpFlav(name, dir) {
    if (dir > 0) {
      if (S.flav.length < maxFlav()) S.flav.push(name);
    } else {
      var i = S.flav.lastIndexOf(name);
      if (i > -1) S.flav.splice(i, 1);
    }
    renderFlavours();
    $('#mb-err').textContent = '';
  }

  root.addEventListener('click', function (e) {
    var t;
    if (e.target.closest('#mb-photo-rm')) { clearPhoto(); return; }
    /* the stepper sits inside the tile, so it has to be caught first */
    if ((t = e.target.closest('[data-qty]'))) {
      e.preventDefault(); e.stopPropagation();
      var bits = t.getAttribute('data-qty').split(':');
      bumpQty(+bits[0], +bits[1]);
      return;
    }
    /* the flavour stepper sits inside its tile too, so it goes above
       [data-flav] for the same reason. Direction first, name second, split on
       the first pipe - flavour names are free text and a colon in one would
       have broken a "name:dir" attribute. */
    if ((t = e.target.closest('[data-fqty]'))) {
      e.preventDefault(); e.stopPropagation();
      var fb = t.getAttribute('data-fqty');
      var fcut = fb.indexOf('|');
      bumpFlav(fb.slice(fcut + 1), +fb.slice(0, fcut));
      return;
    }
    if ((t = e.target.closest('[data-zoom]'))) {
      e.preventDefault(); e.stopPropagation();
      openZoom(+t.getAttribute('data-zoom'));
      return;
    }
    /* also inside the tile, so it has to be caught before [data-extra] */
    if ((t = e.target.closest('[data-xzoom]'))) {
      e.preventDefault(); e.stopPropagation();
      openExtraZoom(+t.getAttribute('data-xzoom'));
      return;
    }
    if ((t = e.target.closest('[data-gal]'))) {
      galTo(S.gal + (+t.getAttribute('data-gal')), true);
    } else if ((t = e.target.closest('[data-galgo]'))) {
      galTo(+t.getAttribute('data-galgo'), true);
    } else if ((t = e.target.closest('[data-bundle]'))) {
      toggleBundle(+t.getAttribute('data-bundle'));
    } else if ((t = e.target.closest('[data-size]'))) {
      S.size = t.getAttribute('data-size');
      if (S.flav.length > maxFlav()) S.flav = S.flav.slice(0, maxFlav());
      renderSizes(); renderFlavours(); renderParcel(); renderBar();
    } else if ((t = e.target.closest('[data-flav]'))) {
      pickFlavour(t.getAttribute('data-flav'));
    } else if ((t = e.target.closest('[data-font]'))) {
      S.font = t.getAttribute('data-font'); S.face = 'msg'; renderMessage();
    } else if ((t = e.target.closest('[data-colour]'))) {
      S.colour = t.getAttribute('data-colour');
      S.face = 'msg';
      renderMessage();
    } else if ((t = e.target.closest('[data-face]'))) {
      S.face = t.getAttribute('data-face'); renderMessage();
    } else if ((t = e.target.closest('[data-when]'))) {
      S.when = t.getAttribute('data-when');
      if (S.when !== 'pick') S.date = null;
      renderWhen(); $('#mb-err').textContent = '';
    } else if ((t = e.target.closest('[data-cal]'))) {
      calMonth = new Date(calMonth.getFullYear(),
        calMonth.getMonth() + (+t.getAttribute('data-cal')), 1);
      renderCal();
    } else if ((t = e.target.closest('[data-day]'))) {
  if (t.getAttribute('data-sunday') === 'true') {
    S.date = null;
    renderCal();

    var sundayNote = $('#mb-sunday-note');
    if (sundayNote) {
      sundayNote.innerHTML =
        "Sorry, Sunday delivery isn’t available with Royal Mail Tracked 24. Please choose another date.";
    }

    return;
  }

  S.date = t.getAttribute('data-day');
  renderCal();
  $('#mb-err').textContent = '';
    } else if ((t = e.target.closest('[data-extra]'))) {
      var id = +t.getAttribute('data-extra'), j = S.extras.indexOf(id);
      if (j > -1) { S.extras.splice(j, 1); delete S.qty[id]; }
      else { S.extras.push(id); S.qty[id] = 1; }
      renderExtras(); renderBundles(); renderParcel(); renderBar();
    } else if (e.target.closest('#mb-next')) { step(1); }
    else if (e.target.closest('#mb-back')) { step(-1); }
  });

  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault(); e.stopPropagation();
      var bits = q.getAttribute('data-qty').split(':');
      bumpQty(+bits[0], +bits[1]);
      return;
    }
    var fq = e.target.closest('[data-fqty]');
    if (fq) {
      e.preventDefault(); e.stopPropagation();
      var fv = fq.getAttribute('data-fqty');
      var fk = fv.indexOf('|');
      bumpFlav(fv.slice(fk + 1), +fv.slice(0, fk));
      return;
    }
    var x = e.target.closest('[data-xzoom]');
    if (x) {
      e.preventDefault(); e.stopPropagation();
      openExtraZoom(+x.getAttribute('data-xzoom'));
      return;
    }
    var t = e.target.closest('[data-zoom]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    openZoom(+t.getAttribute('data-zoom'));
  });

  /* swipe the gallery, because people try it on a phone */
  (function swipe() {
    var x0 = null;
    root.addEventListener('touchstart', function (e) {
      if (!e.target.closest('#mb-gal-vp')) { x0 = null; return; }
      x0 = e.changedTouches[0].clientX;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) galTo(S.gal + (dx < 0 ? 1 : -1), true);
      x0 = null;
    }, { passive: true });
  })();

  /* mb-delivery.js says when the postage changed; the total moves with it */
  document.addEventListener('mb:multibuy:change', function () {
    renderBar();
    touched = true;
    schedulePersist();
  });

  document.addEventListener('mb:postage', function (e) {
    if (e && e.detail && typeof e.detail.base === 'number') {
      BASE_POSTAGE = e.detail.base;
    }
    renderBar();
  });

  if (zoomEl) {
    zoomEl.addEventListener('click', function (e) {
      if (e.target.closest('#mb-zoom-x') || e.target === zoomEl) closeZoom();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !zoomEl.hidden) closeZoom();
    });
  }

  var input = $('#mb-photo-in');
  if (input) {
    input.addEventListener('change', function (e) {
      setPhoto(e.target.files && e.target.files[0]);
    });
  }

  var drop = $('#mb-photo-drop');
  if (drop) {
    ['dragenter', 'dragover'].forEach(function (n) {
      drop.addEventListener(n, function (e) {
        e.preventDefault(); drop.classList.add('is-drag');
      });
    });
    ['dragleave', 'drop'].forEach(function (n) {
      drop.addEventListener(n, function (e) {
        e.preventDefault(); drop.classList.remove('is-drag');
      });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files &&
        e.dataTransfer.files[0]) setPhoto(e.dataTransfer.files[0]);
    });
  }

  var ta = $('#mb-msg');
  if (ta) ta.removeAttribute('maxlength');
  var messageCount = root.querySelector('.mb-cc');
  if (messageCount) messageCount.innerHTML = '<span id="mb-cc">0</span> characters';
  (function buildCardWorkspace() {
    var screen = document.querySelector('.mb-screen[data-step="4"]');
    var stage = $('#mb-stage');
    if (!screen || !stage) return;
    root.classList.add('mb-message-simple');
    var tools = document.createElement('div');
    tools.className = 'mb-message-tools';
    function toolIcon(name) {
      var paths = {
        font: '<path d="M4 20 10 4h4l6 16M7 14h10"/>',
        colour: '<circle cx="12" cy="12" r="8"/><path d="M12 4v16M4 12h16"/>',
        write: '<path d="m4 20 4-1 12-12-3-3L5 16l-1 4M14 7l3 3M4 4v4M2 6h4"/>',
        size: '<path d="M12 3v18M8 7l4-4 4 4M8 17l4 4 4-4"/>',
        align: '<path d="M4 5h16M7 10h10M4 15h16M7 20h10"/>',
        video: '<rect x="3" y="3" width="18" height="18" rx="3"/><path d="m10 8 6 4-6 4z"/>',
        audio: '<path d="M4 9h4l5-4v14l-5-4H4zM17 8a6 6 0 0 1 0 8M20 5a10 10 0 0 1 0 14"/>',
        blank: '<circle cx="12" cy="12" r="9"/><path d="m6 6 12 12"/>'
      };
      return '<svg class="mb-tool-icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+paths[name]+'</svg>';
    }
    var style = screen.querySelector('.mb-style2');
    if (style) {
      tools.appendChild(style);
      style.querySelectorAll('details').forEach(function(d) {
        d.open = false;
        var summary = d.querySelector('summary');
        var isFont = d.id === 'mb-fold-font';
        if (summary) {
          Array.from(summary.childNodes).forEach(function(n) { if (n.nodeType === 3) n.remove(); });
          summary.insertAdjacentHTML('afterbegin', toolIcon(isFont ? 'font' : 'colour') + '<span class="mb-tool-label">'+(isFont ? 'Font' : 'Colour')+'</span>');
        }
        var panel = d.querySelector('.mb-fold__b');
        if (panel) {
          var close = document.createElement('button');
          close.type = 'button'; close.className = 'mb-sheet-close';
          close.setAttribute('aria-label', 'Close ' + (d.id === 'mb-fold-font' ? 'font' : 'colour') + ' options');
          close.textContent = '×';
          close.addEventListener('click', function() { d.open = false; d.querySelector('summary').focus(); });
          panel.insertBefore(close, panel.firstChild);
        }
        d.addEventListener('toggle', function() {
          if (d.open) style.querySelectorAll('details').forEach(function(other) { if (other !== d) other.open = false; });
        });
      });
    }
    var help = screen.querySelector('.mb-helpbtn');
    if (help) { help.innerHTML = toolIcon('write') + '<span class="mb-tool-label">Help me write</span>'; tools.appendChild(help); }
    var more = document.createElement('div'); more.className = 'mb-extra-tools';
    more.innerHTML = ['size','align','video','audio','blank'].map(function(kind) {
      return '<button type="button" '+(kind === 'blank' ? 'data-msg-blank' : 'data-msg-sheet="'+kind+'"')+(kind === 'video' || kind === 'audio' ? ' hidden' : '')+'>'+toolIcon(kind)+'<span class="mb-tool-label">'+kind.charAt(0).toUpperCase()+kind.slice(1)+'</span></button>';
    }).join('');
    tools.appendChild(more);
    var sheet = document.createElement('div'); sheet.className = 'mb-option-sheet'; sheet.hidden = true;
    sheet.setAttribute('role','dialog'); sheet.setAttribute('aria-modal','true'); root.appendChild(sheet);
    var lastTool = null, mediaReady = false, mediaBusy = false;
    var mediaBase = 'https://mailbakes-ops.onrender.com';
    function closeSheet(){ sheet.hidden = true; if(lastTool) lastTool.focus(); }
    function showOptions(kind){
      tools.querySelectorAll('details').forEach(function(d){d.open=false;});
      var title = {size:'Text size',align:'Alignment',video:'Add a video',audio:'Add a voice message'}[kind];
      sheet.setAttribute('aria-label',title);
      var body = '';
      if(kind==='size') body = '<div class="mb-size-grid">' + [0,12,14,16,18,20,24,28,32,36].map(function(n){return '<button type="button" data-msg-size="'+n+'" aria-pressed="'+(S.textSize===n)+'">'+(n||'Auto')+'</button>';}).join('') + '</div>';
      if(kind==='align') body = '<div class="mb-size-grid">' + ['left','center','right'].map(function(a){return '<button type="button" data-msg-align="'+a+'" aria-pressed="'+(S.align===a)+'">'+(a==='center'?'Centre':a.charAt(0).toUpperCase()+a.slice(1))+'</button>';}).join('') + '</div>';
      if(kind==='video'||kind==='audio') {
        var id = S[kind];
        body = '<p>We print a QR code inside your card. They scan it to play your '+(kind==='audio'?'voice message':'video')+'.</p><p>Up to 25 MB. Available for one year after ordering. Anyone with the QR link can play it.</p>' +
          (id ? '<'+kind+' controls playsinline src="'+mediaBase+'/message/'+id+'/file"></'+kind+'><button type="button" data-msg-remove="'+kind+'">Remove recording</button>' : '') +
          '<label class="mb-media-choose">'+(id?'Replace recording':'Choose '+kind)+'<input type="file" data-msg-file="'+kind+'" accept="'+(kind==='video'?'video/mp4,video/quicktime,video/webm':'audio/mpeg,audio/mp4,audio/x-m4a,audio/wav,audio/webm,audio/ogg')+'"></label><p class="mb-media-status" role="status"></p>';
      }
      sheet.innerHTML = '<div class="mb-option-panel"><button class="mb-sheet-close" type="button" aria-label="Close options">×</button><h3>'+title+'</h3>'+body+'</div>';
      sheet.hidden=false; sheet.querySelector('.mb-sheet-close').focus();
    }
    more.addEventListener('click',function(e){
      var b=e.target.closest('button'); if(!b)return;
      lastTool=b;
      if(b.hasAttribute('data-msg-blank')) { S.blank=!S.blank; var blankInput=root.querySelector('#mb-blank');if(blankInput)blankInput.checked=S.blank; if(S.blank){S.msg='';ta.value='';} S.face='msg';renderMessage();schedulePersist();return; }
      var kind=b.getAttribute('data-msg-sheet');
      if((kind==='video'||kind==='audio')&&!mediaReady)return;
      showOptions(kind);
    });
    sheet.addEventListener('click',function(e){
      if(e.target===sheet||e.target.closest('.mb-sheet-close'))return closeSheet();
      var b=e.target.closest('button');if(!b)return;
      if(b.hasAttribute('data-msg-size')) { S.textSize=Number(b.getAttribute('data-msg-size')); renderMessage();schedulePersist();closeSheet(); }
      if(b.hasAttribute('data-msg-align')) { S.align=b.getAttribute('data-msg-align');renderMessage();schedulePersist();closeSheet(); }
      if(b.hasAttribute('data-msg-remove')) { S[b.getAttribute('data-msg-remove')]=null;schedulePersist();closeSheet(); }
    });
    sheet.addEventListener('keydown',function(e){if(e.key==='Escape')closeSheet();});
    sheet.addEventListener('change',function(e){
      var input=e.target;var kind=input.getAttribute('data-msg-file');if(!kind||!input.files[0]||mediaBusy)return;
      var file=input.files[0], status=sheet.querySelector('.mb-media-status');
      if(file.size>25*1024*1024){status.textContent='Please choose a recording under 25 MB.';return;}
      mediaBusy=true;S.mediaBusy=true;input.disabled=true;status.textContent='Saving your recording…';
      var request=new XMLHttpRequest();request.open('POST',mediaBase+'/api/messages/upload');request.timeout=120000;
      request.setRequestHeader('Content-Type',file.type||'application/octet-stream');request.setRequestHeader('X-Media-Kind',kind);
      request.upload.onprogress=function(event){if(event.lengthComputable)status.textContent='Uploading '+Math.round(event.loaded/event.total*100)+'%';};
      function finish(error){mediaBusy=false;S.mediaBusy=false;input.disabled=false;status.textContent=error;}
      request.onerror=function(){finish('Could not save it. Please try again.');};request.ontimeout=request.onerror;
      request.onload=function(){var result;try{result=JSON.parse(request.responseText);}catch(err){}if(request.status!==201||!result||!/^[a-f0-9]{48}$/.test(result.id)){finish(result&&result.error||'Could not save it. Please try again.');return;}S[kind]=result.id;schedulePersist();mediaBusy=false;S.mediaBusy=false;showOptions(kind);sheet.querySelector('.mb-media-status').textContent='Recording saved.';};
      request.send(file);
    });
    fetch(mediaBase+'/api/messages/config').then(function(r){return r.ok?r.json():null;}).then(function(c){if(c&&c.enabled){mediaReady=true;more.querySelectorAll('[data-msg-sheet="video"],[data-msg-sheet="audio"]').forEach(function(b){b.hidden=false;});}}).catch(function(){});
    var controlsCss=document.createElement('style');controlsCss.textContent=`
      .mb-message-tools{overflow-x:auto;overflow-y:visible;gap:6px!important;padding-bottom:3px}
      .mb-message-tools .mb-style2{display:flex!important;flex:none!important;gap:6px}
      .mb-message-tools .mb-fold,.mb-message-tools>.mb-helpbtn{flex:none!important;width:74px!important}
      .mb-message-tools>.mb-helpbtn{white-space:normal!important;font-size:12px!important}
      .mb-extra-tools{display:flex;gap:6px;flex:none}
      .mb-extra-tools button{width:64px;min-height:48px;border:1px solid #EDE6E9;background:white;border-radius:10px;font-size:20px;cursor:pointer;color:#251d22}
      .mb-extra-tools button[hidden]{display:none}
      .mb-extra-tools span{display:block;font-size:12px;font-weight:600}
      .mb-option-sheet:not([hidden]){display:flex;position:fixed;inset:0;align-items:flex-end;justify-content:center;background:#0004;z-index:1500}
      .mb-option-panel{position:relative;background:#fff;border-radius:18px 18px 0 0;padding:16px;box-sizing:border-box;width:100%;max-width:620px;max-height:75dvh;overflow:auto}
      .mb-option-panel .mb-sheet-close{position:absolute!important;top:8px!important;right:12px!important}
      .mb-message-simple .mb-pv__t{text-align:inherit!important;font-weight:inherit!important}
      .mb-option-panel h3{font-size:20px;margin:4px 44px 16px 0}
      .mb-option-panel p{font-size:14px;line-height:1.45}
      .mb-size-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:8px}
      .mb-size-grid button,.mb-option-panel>button:not(.mb-sheet-close){padding:12px;min-height:48px;border:1px solid #ddd;border-radius:10px;background:#fff;font:inherit}
      .mb-size-grid [aria-pressed="true"]{border:2px solid #ec167e;background:#fff0f7}
      .mb-option-panel video,.mb-option-panel audio{display:block;max-height:200px;max-width:100%;width:100%;margin:12px 0}
      .mb-media-choose{display:block;margin-top:12px;font-weight:600;padding:12px;background:#fff0f7;border-radius:10px}
      .mb-media-choose input{display:block;width:100%;margin-top:8px}
      .mb-message-tools .mb-fold__b{position:fixed!important;top:auto!important;bottom:0!important;left:0!important;right:0!important;max-height:70dvh;overflow:auto;z-index:1600;border-radius:18px 18px 0 0!important}
    `;document.head.appendChild(controlsCss);
    stage.parentNode.insertBefore(tools, stage);
    var modal = screen.querySelector('.mb-modal');
    if (modal) root.appendChild(modal);
    tools.addEventListener('click', function(e) {
      if (e.target.closest('[data-font],[data-colour]')) tools.querySelectorAll('details').forEach(function(d) { d.open = false; });
    });
    var blank = screen.querySelector('.mb-blank');
    if (blank) stage.parentNode.insertBefore(blank, stage.nextSibling);
    var count = screen.querySelector('.mb-cc');
    if (count) { count.classList.add('mb-message-count'); stage.parentNode.insertBefore(count, stage.nextSibling); }
    root.addEventListener('click', function(e) {
      var page = e.target.closest('[data-go]');
      if (!page || !screen.classList.contains('is-on')) return;
      S.face = page.getAttribute('data-go') === 'inside' ? 'msg' : 'card';
      renderMessage();
    }, true);
    var css = document.createElement('style');
    css.textContent = `
      .mb-message-simple .mb-screen[data-step="4"] .mb-fhead{display:none!important}
      .mb-message-simple .mb-screen[data-step="4"] .mb-two{display:block!important;max-width:620px;margin:0 auto}
      .mb-message-simple[data-message-face="msg"] .mb-screen[data-step="4"] .mb-two>div:nth-child(2)>*:not(#mb-photo):not(.mbd1-strip){display:none!important}
      .mb-message-simple[data-message-face="msg"] #mb-photo,.mb-message-simple .mbd1-tools{display:none!important}
      .mb-message-simple[data-message-face="card"] .mb-message-tools,.mb-message-simple[data-message-face="card"] .mb-message-count,.mb-message-simple[data-message-face="card"] .mb-blank{display:none!important}
      .mb-message-simple[data-message-face="msg"] .mb-reassure{display:none!important}
      .mb-message-tools{display:flex;align-items:stretch;gap:8px;margin:0 auto 12px;max-width:390px;position:relative;z-index:100}
      .mb-message-tools .mb-style2{display:grid!important;grid-template-columns:1fr 1fr!important;gap:8px;margin:0!important;flex:2}
      .mb-message-tools .mb-fold{position:static!important;border:0!important;background:none!important;border-radius:0!important}
      .mb-message-tools .mb-fold>summary,.mb-message-tools>.mb-helpbtn{font-family:inherit;font-size:14px;font-weight:600;line-height:1.2;min-height:44px;border:1px solid #EDE6E9;border-radius:10px;padding:12px 8px;background:#fff;color:#1E1A1C;cursor:pointer;box-sizing:border-box;text-align:center;list-style:none;display:block!important}
      .mb-message-tools summary small,.mb-message-tools summary:after{display:none!important}
      .mb-message-tools>.mb-helpbtn{flex:1;margin:0;display:block!important;white-space:nowrap}
      .mb-message-tools .mb-fold__b{position:absolute;z-index:101;left:0;right:0;top:50px;padding:14px;background:#fff;border:1px solid #EDE6E9;border-radius:12px;box-shadow:0 8px 24px #0002}
      .mb-message-tools .mb-fonts{display:grid;grid-template-columns:1fr 1fr;gap:8px}
      .mb-message-tools .mb-fonts button{font-size:15px;min-height:44px;width:auto}
      .mb-message-simple[data-message-face="msg"] #mb-stage{position:relative!important;z-index:0!important;background:none!important;border:0!important;padding:0!important;display:block!important;margin:0 auto!important;width:100%!important;max-width:390px!important}
      .mb-message-simple .mb-pv{width:100%!important;max-width:390px!important;box-sizing:border-box;border-radius:3px!important;overflow:hidden;padding:28px 24px 16px!important}
      .mb-message-simple .mb-pv__t{padding:0!important;border:0!important;min-height:96px;display:block;white-space:pre-wrap}
      .mb-message-simple .mb-pv__t:empty{display:flex;align-items:center;justify-content:center;border:1px dashed #A79FA3!important;background:#FBFAFA}
      .mb-message-simple .mb-pv__t:empty::before{font-family:system-ui,sans-serif;font-size:16px;color:#6B6367}
      .mb-message-simple .mb-blank{justify-content:center;margin:6px 0!important;font-size:13px;min-height:30px}
      .mb-message-simple .mb-message-count{text-align:center;margin:6px 0 0;font-size:11px;color:#6B6367}
      .mb-message-simple .mb-modal.is-open{display:flex!important;z-index:1000}
      .mb-message-simple .mb-restore-note{font-size:12px!important;padding:8px 10px!important;margin:0 0 8px!important}
      @media(max-width:600px){
        .mb-message-simple .mb-screen[data-step="4"]{padding-top:8px!important}
        .mb-message-simple[data-message-face="msg"] #mb-stage{max-width:248px!important}
        .mb-message-simple .mb-pv{max-width:248px!important;aspect-ratio:1/1.414}
        .mb-message-simple .mb-pv__m{font-size:15.5px;line-height:1.55}
        .mb-message-simple[data-message-face="msg"] .mbd1-strip{margin-top:6px!important;padding-top:4px!important;display:flex!important}
      }
    `;
    css.textContent += `
      .mb-message-simple:has(.mb-screen[data-step="4"].is-on){position:fixed!important;inset:0!important;z-index:2147483000!important;background:#F5F3F4;overflow:hidden!important;margin:0!important;padding:0!important;height:100dvh!important}
      .mb-message-simple .mb-screen[data-step="4"].is-on{position:absolute!important;inset:64px 0 0!important;padding:0!important;overflow:hidden!important;display:block!important}
      .mb-message-simple .mb-screen[data-step="4"]>.mb-wrap{height:100%!important;max-width:760px!important;box-sizing:border-box;padding:8px 12px 0!important;margin:auto!important;display:flex;flex-direction:column}
      .mb-message-simple:has(.mb-screen[data-step="4"].is-on) .mb-bar{position:fixed!important;inset:0 0 auto!important;height:64px!important;padding:0!important;background:#fff!important;box-shadow:0 1px 4px #0001!important;z-index:20!important}
      .mb-message-simple:has(.mb-screen[data-step="4"].is-on) .mb-bar__in{padding:8px 12px!important;display:block!important;max-width:760px!important;height:64px;box-sizing:border-box;margin:auto}
      .mb-message-simple:has(.mb-screen[data-step="4"].is-on) .mb-bar__pr,.mb-message-simple:has(.mb-screen[data-step="4"].is-on) .mb-bar__md{display:none!important}
      .mb-message-simple:has(.mb-screen[data-step="4"].is-on) .mb-bar__nv{display:flex!important;justify-content:space-between!important;gap:16px!important;width:100%!important}
      .mb-message-simple:has(.mb-screen[data-step="4"].is-on) #mb-back{min-width:0!important;width:auto!important;flex:none!important;padding:10px 12px!important;border:0!important;background:none!important}
      .mb-message-simple:has(.mb-screen[data-step="4"].is-on) #mb-next{min-width:0!important;width:auto!important;flex:none!important;padding:10px 22px!important;height:48px!important;border-radius:10px!important}
      .mb-message-simple .mb-screen[data-step="4"] .mb-two{flex:1!important;min-height:0!important;max-width:none!important;width:100%!important;display:flex!important;flex-direction:column!important}
      .mb-message-simple .mb-screen[data-step="4"] .mb-two>div:first-child{display:flex!important;flex-direction:column!important;flex:1!important;min-height:0!important}
      .mb-message-simple .mb-flip{margin:0 0 6px!important;flex-shrink:0}
      .mb-message-simple .mb-message-tools{width:100%;max-width:none;flex-shrink:0;margin-bottom:8px}
      .mb-message-simple #mb-stage{position:relative!important;display:flex!important;align-items:center!important;justify-content:center!important;flex:1!important;min-height:0!important;max-height:none!important;height:auto!important;width:100%!important;max-width:none!important;border:0!important;background:transparent!important;padding:0!important;margin:0!important;overflow:hidden!important}
      .mb-message-simple #mb-stage>.mb-pv,.mb-message-simple #mb-stage>img{width:auto!important;height:100%!important;max-height:100%!important;max-width:100%!important;aspect-ratio:1/1.414!important;object-fit:cover!important;border-radius:0!important;margin:0!important;box-sizing:border-box}
      .mb-message-simple #mb-stage>.mb-pv{padding:24px 20px 12px!important;box-shadow:0 2px 8px #0001}
      .mb-message-simple .mb-message-count{margin:4px 0 0!important;flex-shrink:0}
      .mb-message-simple .mb-blank{margin:0!important;min-height:30px!important;flex-shrink:0}
      .mb-message-simple .mbd1-strip{padding:4px 0!important;margin:0!important;min-height:0!important}
      .mb-message-tools .mb-fold__b{position:fixed!important;inset:auto 0 0!important;z-index:100!important;border-radius:18px 18px 0 0!important;max-height:45dvh!important;overflow:auto!important;padding:48px 16px 16px!important;box-shadow:0 -4px 24px #0002!important}
      .mb-sheet-close{position:absolute;right:12px;top:8px;width:40px;height:40px;border:0;background:none;font-size:30px;line-height:1;cursor:pointer;color:#1E1A1C}
      .mb-message-simple .mb-modal.is-open{position:fixed!important;inset:0!important;align-items:flex-end!important;padding:0!important}
      .mb-message-simple .mb-restore-note{flex-shrink:0}
    `;
    css.textContent += `
      .mb-message-simple[data-message-face] .mb-screen[data-step="4"] .mb-two{gap:0!important;grid-template-columns:none!important}
      .mb-message-simple[data-message-face] .mb-screen[data-step="4"] .mb-two>div:first-child{position:static!important;top:auto!important;width:100%!important;max-width:none!important;margin:0!important}
      .mb-message-simple[data-message-face] .mb-screen[data-step="4"] .mb-two>div:nth-child(2){width:100%!important;margin:0!important;padding:0!important}
      .mb-message-simple[data-message-face] #mb-stage{display:flex!important;max-width:none!important;min-height:0!important;height:auto!important;flex:1 1 0!important;margin:0!important;padding:0!important;width:100%!important}
      .mb-message-simple[data-message-face] #mb-stage>.mb-pv{max-width:100%!important;width:auto!important;height:100%!important;max-height:100%!important}
      .mb-message-simple[data-message-face] .mb-message-count,.mb-message-simple[data-message-face] .mb-blank{position:static!important;transform:none!important;opacity:1!important;color:#6B6367!important;width:auto!important}
      .mb-message-simple .mbd1-strip{justify-content:center!important;height:64px!important;box-sizing:border-box}
      .mb-message-simple .mbd1-strip img{max-height:48px!important}
      .mb-message-simple .mb-message-tools .mb-fold__b{color:#1E1A1C!important}
    `;
    css.textContent += `
      .mb-message-simple[data-message-face] #mb-stage{top:auto!important;bottom:auto!important;left:auto!important;right:auto!important}
      body:has(.mb-message-simple .mb-screen[data-step="4"].is-on) shopify-chat{display:none!important}
    `;
    document.head.appendChild(css);
    stage.addEventListener('focusin', function() { document.body.classList.add('mbd1-typing'); });
    stage.addEventListener('focusout', function() { document.body.classList.remove('mbd1-typing'); });
  })();
  ta.addEventListener('input', function (e) {
    S.msg = e.target.value;
    if (S.msg.trim()) { S.blank = false; var blankChoice = $('#mb-blank'); if (blankChoice) blankChoice.checked = false; }
    if (S.face !== 'msg') S.face = 'msg';
    renderMessage();
    $('#mb-err').textContent = '';
  });

  /* ---- typing on the card --------------------------------------------
     The customer writes straight onto the preview. The old box is still in
     the DOM, off-screen, because the message helper writes into it and a
     basket edit restores into it - so the two are kept in step here, with
     the card as the thing that has focus and the box as the value.        */

  function caretToEnd(el) {
    try {
      var r = document.createRange();
      r.selectNodeContents(el);
      r.collapse(false);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
    } catch (err) { /* selection is best effort */ }
  }

  var NBSP = String.fromCharCode(160);

  function cardText(el) {
    /* innerText, not textContent: it turns the browser's <div>/<br> line
       breaks back into newlines, which is what gets printed. A browser
       inserts non-breaking spaces while editing; they are ordinary
       spaces as far as the printed card is concerned. */
    return (el.innerText || '')
      .split(NBSP).join(' ')
      .replace(/\r/g, '')
      .replace(/\n{3,}/g, '\n\n');
  }

  function syncFromCard(el) {
    var txt = cardText(el);
    S.msg = txt;
    if (ta) ta.value = txt;
    var host = el.parentNode;
    if (host && host.classList) host.classList.toggle('is-empty', !txt.trim());
    var cc = document.getElementById('mb-cc');
    if (cc) cc.textContent = txt.length;
    $('#mb-err').textContent = '';
  }

  var stageEl = $('#mb-stage');
  if (stageEl) {
    stageEl.addEventListener('input', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('.mb-pv__t') : null;
      if (el) syncFromCard(el);
    });
    /* contenteditable would otherwise accept pasted markup wholesale */
    stageEl.addEventListener('paste', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('.mb-pv__t') : null;
      if (!el) return;
      e.preventDefault();
      var cb = e.clipboardData || window.clipboardData;
      var txt = cb ? cb.getData('text') : '';
      if (txt) document.execCommand('insertText', false, txt.replace(/\r/g, ''));
    });
  }

  /* The helper focuses the old box after "Use this". Send that focus to the
     card instead, so the caret lands where the customer is looking. */
  ta.addEventListener('focus', function () {
    var el = document.querySelector('.mb-pv__t[contenteditable]');
    if (el) { el.focus(); caretToEnd(el); }
  });

  var blankBox = document.getElementById('mb-blank');
  if (blankBox) {
    blankBox.addEventListener('change', function () {
      S.blank = blankBox.checked;
      if (S.blank) { S.msg = ''; if (ta) ta.value = ''; }
      if (S.face !== 'msg') S.face = 'msg';
      renderMessage();
      $('#mb-err').textContent = '';
      if (!S.blank) {
        var el = document.querySelector('.mb-pv__t[contenteditable]');
        if (el) { el.focus(); caretToEnd(el); }
      }
    });
  }

  /* Step-4 wording for photo cards only - a plain card keeps whatever the
     section settings say. Step 4 is never the first screen. */
  (function stepFourCopy() {
    if (!D.needs_image) return;
    var h = document.getElementById('mb-s4-h');
    var fc = document.getElementById('mb-face-card');
    /* The AI card asks for nothing here but the words, so it keeps the
       ordinary step-4 heading from the section settings (item 3). */
    if (D.is_ai) return;
    if (h) h.textContent = 'Your photo and message';
    if (fc) fc.textContent = 'Your photo';
  })();

  renderAll();
  showStep();
  wireRecovery();
  bootEdit().then(function (found) { if (!found) bootConfig(); });
})();
/* Compact shared front/inside workspace, October 11. */
(function () {
  var root = document.querySelector('.mb-message-simple');
  if (!root) return;
  var screen = root.querySelector('.mb-screen[data-step="4"]');
  var two = screen && screen.querySelector('.mb-two');
  if (!two) return;
  function placeTabs() {
    var tabs = root.querySelector('.mbd1-strip');
    if (tabs && tabs.parentNode !== two.parentNode) two.parentNode.insertBefore(tabs, two);
  }
  placeTabs();
  var observer = new MutationObserver(placeTabs);
  observer.observe(two, {childList:true, subtree:true});
  var css = document.createElement('style');
  css.id = 'mb-compact-photo-workspace';
  css.textContent = `
    .mb-message-simple[data-message-face="card"] #mb-stage.mbd1-stage-off{display:none!important}
    .mb-message-simple .mb-screen[data-step="4"]>.mb-wrap{padding:4px 8px 0!important}
    .mb-message-simple .mbd1-strip{height:44px!important;flex:0 0 44px!important;gap:8px!important;margin:0!important;padding:2px 0 6px!important;align-items:center!important}
    .mb-message-simple .mbd1-strip__arw,.mb-message-simple .mbd1-strip__cv,.mb-message-simple .mbd1-strip__in{display:none!important}
    .mb-message-simple .mbd1-strip__pg{width:auto!important;height:36px!important;min-width:90px!important;padding:6px 18px!important;border-radius:20px!important;display:block!important;font-size:14px!important;box-shadow:none!important}
    .mb-message-simple[data-message-face="card"] .mb-screen[data-step="4"] .mb-two>div:first-child{display:none!important}
    .mb-message-simple[data-message-face="card"] .mb-screen[data-step="4"] .mb-two>div:nth-child(2){display:flex!important;flex:1 1 0!important;min-height:0!important;flex-direction:column!important}
    .mb-message-simple[data-message-face="card"] .mb-screen[data-step="4"] .mb-two>div:nth-child(2)>*:not(#mb-photo){display:none!important}
    .mb-message-simple[data-message-face="card"] #mb-photo{display:flex!important;flex:1 1 0!important;min-height:0!important;height:100%!important;margin:0!important;padding:0!important;border:0!important;background:none!important;box-shadow:none!important}
    .mb-message-simple #mb-photo .mbd{display:flex!important;flex-direction:column!important;flex:1!important;min-height:0!important;gap:6px!important;padding:0!important;margin:0!important;background:none!important;border:0!important;box-shadow:none!important}
    .mb-message-simple #mb-photo .mbd>h3,.mb-message-simple #mb-photo .mbd__sub,.mb-message-simple #mb-photo .mbd__tip{display:none!important}
    .mb-message-simple #mb-photo .mbd1__below{order:-1!important;margin:0!important;padding:0!important;border:0!important;background:none!important;flex-shrink:0!important}
    .mb-message-simple #mb-photo .mbd__ctl:not([hidden]){display:flex!important;align-items:center!important;gap:8px!important;padding:0!important;margin:0!important}
    .mb-message-simple #mb-photo .mbd1__change{font-size:13px!important;padding:8px 12px!important;min-height:40px!important;white-space:nowrap!important}
    .mb-message-simple #mb-photo .mbd__zoom{flex:1!important;width:0!important;min-width:40px!important;margin:0!important;height:40px!important}
    .mb-message-simple #mb-photo .mbd__rm{font-size:12px!important;min-height:40px!important;padding:6px!important;margin:0!important}
    .mb-message-simple #mb-photo .mbd__pv{position:relative!important;display:flex!important;align-items:center!important;justify-content:center!important;flex:1 1 0!important;min-height:0!important;height:auto!important;max-height:none!important;width:100%!important;padding:0!important;margin:0!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;overflow:hidden!important;container-type:size!important}
    .mb-message-simple #mb-photo .mbd1__card{position:relative!important;height:auto!important;width:min(100cqw,calc(100cqh * 640 / 908))!important;aspect-ratio:640/908!important;max-height:100%!important;max-width:100%!important;margin:0!important;border:0!important;border-radius:0!important;box-shadow:none!important}
    .mb-message-simple #mb-photo .mbd__cv{display:block!important;width:100%!important;height:100%!important;border:0!important;border-radius:0!important;box-shadow:none!important}
    .mb-message-simple #mb-photo .mbd__err{margin:0!important;font-size:12px!important}
  `;
  document.head.appendChild(css);
})();

/* Consistent toolbar tiles and standard-card front preview. */
(function () {
  var css = document.createElement('style');
  css.id = 'mb-toolbar-front-oct12';
  css.textContent = `
    .mb-message-simple .mb-message-tools{align-items:flex-start!important;gap:6px!important;min-height:64px!important;padding:0 0 4px!important}
    .mb-message-simple .mb-message-tools .mb-style2,.mb-message-simple .mb-extra-tools{display:flex!important;gap:6px!important;flex:none!important}
    .mb-message-simple .mb-message-tools .mb-fold{width:64px!important;height:64px!important;flex:0 0 64px!important}
    .mb-message-simple .mb-message-tools .mb-fold>summary,
    .mb-message-simple .mb-message-tools>.mb-helpbtn,
    .mb-message-simple .mb-extra-tools button:not([hidden]){display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:4px!important;width:64px!important;min-width:64px!important;height:64px!important;min-height:64px!important;max-height:64px!important;flex:0 0 64px!important;padding:6px 4px!important;margin:0!important;box-sizing:border-box!important;border:1px solid #EDE6E9!important;border-radius:10px!important;background:#fff!important;color:#251d22!important}
    .mb-message-simple .mb-tool-icon{display:block!important;width:24px!important;height:24px!important;min-width:24px!important;flex:0 0 24px!important}
    .mb-message-simple .mb-tool-label{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;height:22px!important;min-height:22px!important;font-family:inherit!important;font-size:11px!important;font-weight:600!important;line-height:11px!important;white-space:normal!important;text-align:center!important}
    .mb-message-simple #mb-photo[hidden]{display:none!important}
    .mb-message-simple[data-message-face="card"]:not(:has(#mb-photo .mbd1__card)) .mb-screen[data-step="4"] .mb-two>div:first-child{display:flex!important;flex-direction:column!important;flex:1!important;min-height:0!important}
    .mb-message-simple[data-message-face="card"]:not(:has(#mb-photo .mbd1__card)) .mb-screen[data-step="4"] .mb-two>div:nth-child(2){display:none!important}
    .mb-message-simple[data-message-face="card"]:not(:has(#mb-photo .mbd1__card)) #mb-stage{display:flex!important;container-type:size!important}
    .mb-message-simple[data-message-face="card"]:not(:has(#mb-photo .mbd1__card)) #mb-stage>img{width:min(100cqw,calc(100cqh / 1.414))!important;height:auto!important;max-width:100%!important;max-height:100%!important;object-fit:contain!important;aspect-ratio:1/1.414!important}
  `;
  document.head.appendChild(css);
})();

/* Phone flavour picker: navigation remains visible above a compact grid. */
(function () {
  var css = document.createElement('style');
  css.textContent = `
  @media(max-width:600px){
    .mb-message-simple:has(.mb-screen[data-step="3"].is-on){position:fixed!important;inset:0!important;height:100dvh!important;overflow:hidden!important;background:#FFF5F8!important;z-index:2147483000!important;padding:0!important;margin:0!important}
    .mb-message-simple .mb-screen[data-step="3"].is-on{position:absolute!important;inset:64px 0 0!important;padding:0!important;overflow:auto!important}
    .mb-message-simple .mb-screen[data-step="3"]>.mb-wrap{padding:12px 12px 8px!important;margin:0!important;max-width:none!important;height:100%!important;box-sizing:border-box!important;display:flex!important;flex-direction:column!important;gap:8px!important}
    .mb-message-simple .mb-screen[data-step="3"] .mb-fhead{padding:0!important;margin:0!important;flex:none!important}
    .mb-message-simple .mb-screen[data-step="3"] h2{font-size:24px!important;line-height:1.15!important;margin:0!important}
    .mb-message-simple .mb-screen[data-step="3"] .mb-fsub{font-size:13px!important;line-height:1.3!important;margin:5px 0 0!important}
    .mb-message-simple .mb-screen[data-step="3"] #mb-fhint{display:none!important}
    .mb-message-simple .mb-screen[data-step="3"] #mb-flavs{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;grid-auto-rows:1fr!important;gap:8px!important;width:100%!important;flex:1 1 0!important;min-height:400px!important;margin:0!important}
    .mb-message-simple .mb-screen[data-step="3"] .mb-flav{min-height:90px!important;padding:10px 24px 6px 8px!important;gap:4px!important;flex-direction:column!important;border-radius:12px!important;font-size:14px!important;line-height:1.15!important}
    .mb-message-simple .mb-screen[data-step="3"] .mb-flav__n{font-size:14px!important;line-height:1.15!important;margin:0!important}
    .mb-message-simple .mb-screen[data-step="3"] .mb-flav__zoom{width:28px!important;height:28px!important;top:2px!important;right:2px!important}
    .mb-message-simple .mb-screen[data-step="3"] .mb-flav__tk{left:4px!important;right:auto!important;top:4px!important;font-size:12px!important}
    .mb-message-simple .mb-screen[data-step="3"] .mb-qty--flav{height:44px!important;min-height:44px!important;margin:0!important;width:120px!important;max-width:100%!important}
    .mb-message-simple .mb-screen[data-step="3"] .mb-qty--flav>[role="button"]{min-height:44px!important;min-width:36px!important;display:flex!important;align-items:center!important;justify-content:center!important}
    .mb-message-simple .mb-screen[data-step="3"] #mb-fcount{flex:none!important;font-size:14px!important;line-height:20px!important;margin:0!important;padding:4px!important}
    .mb-message-simple:has(.mb-screen[data-step="3"].is-on) .mb-bar{position:fixed!important;inset:0 0 auto!important;height:64px!important;padding:0!important;background:#fff!important;box-shadow:0 1px 4px #0001!important;z-index:20!important}
    .mb-message-simple:has(.mb-screen[data-step="3"].is-on) .mb-bar__in{padding:8px 12px!important;display:block!important;max-width:none!important;height:64px!important;box-sizing:border-box!important}
    .mb-message-simple:has(.mb-screen[data-step="3"].is-on) .mb-bar__pr,.mb-message-simple:has(.mb-screen[data-step="3"].is-on) .mb-bar__md{display:none!important}
    .mb-message-simple:has(.mb-screen[data-step="3"].is-on) .mb-bar__nv{display:flex!important;justify-content:space-between!important;gap:16px!important;width:100%!important}
    .mb-message-simple:has(.mb-screen[data-step="3"].is-on) #mb-back{min-width:0!important;width:auto!important;flex:none!important;padding:10px 12px!important;border:0!important;background:none!important}
    .mb-message-simple:has(.mb-screen[data-step="3"].is-on) #mb-next{min-width:0!important;width:auto!important;flex:none!important;padding:10px 22px!important;height:48px!important;border-radius:10px!important}
    body:has(.mb-message-simple .mb-screen[data-step="3"].is-on) shopify-chat{display:none!important}
  }
  `;
  document.head.appendChild(css);
})();

(function () {
  var css=document.createElement('style');
  css.textContent=`
    .mb-message-simple #mb-zoom:not([hidden]){display:flex!important;position:fixed!important;inset:0!important;z-index:300!important;align-items:flex-end!important;justify-content:center!important;padding:0!important;background:#0005!important}
    .mb-message-simple #mb-zoom .mb-zoom__d{position:relative!important;width:100%!important;max-width:600px!important;max-height:85dvh!important;overflow:auto!important;border-radius:18px 18px 0 0!important;background:#fff!important}
    .mb-message-simple #mb-zoom .mb-zoom__x{position:sticky!important;float:right!important;top:8px!important;right:8px!important;z-index:3!important;min-width:44px!important;min-height:44px!important}
    .mb-message-simple #mb-zoom .mb-zoom__im{max-height:180px!important;width:100%!important;object-fit:cover!important}
    .mb-message-simple .mb-flav__photo{display:block;width:64px;height:52px;object-fit:cover;border-radius:8px;flex-shrink:0}
    @media(max-width:600px){
      .mb-message-simple:has(.mb-screen.is-on){position:fixed!important;inset:0!important;height:100dvh!important;overflow:hidden!important;background:#FFF5F8!important;z-index:2147483000!important;padding:0!important;margin:0!important}
      .mb-message-simple .mb-screen.is-on{position:absolute!important;inset:64px 0 0!important;padding:0!important;overflow:auto!important}
      .mb-message-simple .mb-screen[data-step="4"].is-on{overflow:hidden!important}
      .mb-message-simple:has(.mb-screen.is-on) .mb-bar{position:fixed!important;inset:0 0 auto!important;height:64px!important;padding:0!important;background:#fff!important;box-shadow:0 1px 4px #0001!important;z-index:20!important}
      .mb-message-simple:has(.mb-screen.is-on) .mb-bar__in{padding:8px 12px!important;display:block!important;max-width:none!important;height:64px!important;box-sizing:border-box!important}
      .mb-message-simple:has(.mb-screen.is-on) .mb-bar__pr,.mb-message-simple:has(.mb-screen.is-on) .mb-bar__md{display:none!important}
      .mb-message-simple:has(.mb-screen.is-on) .mb-bar__nv{display:flex!important;justify-content:space-between!important;gap:16px!important;width:100%!important}
      .mb-message-simple:has(.mb-screen.is-on) #mb-back{min-width:0!important;width:auto!important;flex:none!important;padding:10px 12px!important;border:0!important;background:none!important;font-size:14px!important}
      .mb-message-simple:has(.mb-screen.is-on) #mb-next{min-width:0!important;width:auto!important;flex:none!important;padding:10px 22px!important;height:48px!important;border-radius:10px!important;font-size:14px!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav{padding:7px 26px 3px 7px!important;gap:3px!important;justify-content:center!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav{position:relative!important;padding:0!important;overflow:hidden!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav__photo{position:absolute!important;inset:0 0 auto!important;width:100%!important;height:calc(100% - 30px)!important;object-fit:cover!important;border-radius:0!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav.is-on .mb-flav__photo{height:calc(100% - 68px)!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav__n{position:absolute!important;bottom:3px!important;left:4px!important;right:4px!important;background:#fff!important;padding:3px 0!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav.is-on .mb-flav__n{bottom:46px!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-qty--flav{position:absolute!important;bottom:3px!important;left:50%!important;transform:translateX(-50%);background:#fff!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav__zoom{background:#fff!important;box-shadow:0 1px 4px #0002!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav__tk{z-index:2!important;background:#fff!important;border-radius:50%;width:18px;height:18px}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav__n{font-size:13px!important;line-height:1.05!important}
      .mb-message-simple .mb-screen[data-step="3"] .mb-flav__zoom{width:32px!important;height:32px!important;right:0!important;top:0!important;z-index:2!important}
      .mb-message-simple .mb-screen[data-step="2"]>.mb-wrap,.mb-message-simple .mb-screen[data-step="5"]>.mb-wrap,.mb-message-simple .mb-screen[data-step="6"]>.mb-wrap{padding:12px!important;margin:0!important}
      .mb-message-simple .mb-screen[data-step="2"] .mb-fhead,.mb-message-simple .mb-screen[data-step="5"] .mb-fhead{margin:0 0 12px!important;padding:0!important}
      .mb-message-simple .mb-screen[data-step="2"] h2,.mb-message-simple .mb-screen[data-step="5"] h2{font-size:24px!important;line-height:1.2!important;margin:0!important}
      .mb-message-simple .mb-screen[data-step="2"] .mb-des__n{font-size:17px!important;line-height:1.2!important;margin:0 0 4px!important}
      .mb-message-simple .mb-screen[data-step="2"] .mb-des__rt{font-size:12px!important;margin:0 0 6px!important}
      .mb-message-simple .mb-screen[data-step="2"] .mb-two{gap:12px!important}
      .mb-message-simple .mb-screen[data-step="2"] #mb-gal{padding:0!important;border:0!important;background:none!important;max-height:180px!important;width:130px!important;margin:0 auto!important}
      .mb-message-simple .mb-screen[data-step="2"] #mb-gal img{max-height:180px!important;object-fit:contain!important}
      body:has(.mb-message-simple .mb-screen.is-on) shopify-chat{display:none!important}
    }
  `;
  document.head.appendChild(css);
})();

/* October 2026 maintenance: keep the running quote visible beside navigation. */
(function(){var css=document.createElement('style');css.id='mb-maintenance-bar';css.textContent=`
@media(max-width:600px){
.mb-message-simple:has(.mb-screen.is-on) .mb-bar .mb-bar__in{display:grid!important;grid-template-columns:minmax(66px,1fr) minmax(90px,1.25fr) minmax(100px,1.1fr)!important;gap:6px!important;align-items:center!important;padding:8px!important;}
.mb-message-simple:has(.mb-screen.is-on) .mb-bar .mb-bar__pr{display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;order:2!important;min-width:0!important;margin:0!important;line-height:1.15!important;}
.mb-message-simple:has(.mb-screen.is-on) .mb-bar #mb-price{font-size:17px!important;font-weight:700!important;}
.mb-message-simple:has(.mb-screen.is-on) .mb-bar #mb-bar-sub{font-size:10px!important;line-height:1.2!important;text-align:center!important;display:-webkit-box!important;-webkit-box-orient:vertical!important;-webkit-line-clamp:2!important;overflow:hidden!important;margin-top:3px!important;}
.mb-message-simple:has(.mb-screen.is-on) .mb-bar .mb-bar__nv{display:contents!important;}
.mb-message-simple:has(.mb-screen.is-on) .mb-bar #mb-back{order:1!important;width:100%!important;padding:6px!important;font-size:12px!important;white-space:normal!important;line-height:1.2!important;}
.mb-message-simple:has(.mb-screen.is-on) .mb-bar #mb-next{order:3!important;width:100%!important;padding:6px 8px!important;font-size:12px!important;line-height:1.2!important;white-space:normal!important;}
}
.mb-flow .mb-dwrap .mb-dblk--when{order:1}.mb-flow .mb-dwrap .mb-dblk--travel{order:2;margin-top:20px;padding-top:16px;border-top:1px solid #ede6e9}
.mb-flow .mbfr-more{margin-top:10px;border:1px solid #ed217a;color:#b41459;background:#fff;border-radius:24px;padding:10px 18px;font:inherit;font-size:13px;cursor:pointer;}
.mb-flow .mbfr-rail-x [hidden]{display:none!important;}
`;document.head.appendChild(css);})();
